{
  "common": {
    "actions": "Actions",
    "add": "Add",
    "all": "All",
    "back": "Back",
    "cancel": "Cancel",
    "close": "Close",
    "confirm": "Confirm",
    "copied": "Copied",
    "copy": "Copy",
    "copyFailed": "Could not copy to the clipboard",
    "create": "Create",
    "delete": "Delete",
    "description": "Description",
    "edit": "Edit",
    "goHome": "Go to home",
    "loading": "Loading…",
    "next": "Next",
    "no": "No",
    "remove": "Remove",
    "retry": "Try again",
    "save": "Save",
    "saved": "Saved",
    "search": "Search",
    "view": "View",
    "yes": "Yes",
    "you": "you"
  },
  "nav": {
    "activity": "My activity",
    "adminFraud": "Linked accounts",
    "adminOverview": "Overview",
    "adminUsers": "Users",
    "allLogs": "All logs",
    "assignments": "My assignments",
    "billing": "Payments",
    "communities": "Communities",
    "devices": "My devices",
    "disputes": "Disputes",
    "earnings": "Earnings",
    "exploratory": "Exploratory testing",
    "getStarted": "Get started",
    "jobs": "Jobs",
    "logs": "Logs",
    "myBugs": "My bug reports",
    "myDisputes": "My disputes",
    "organization": "Organization",
    "payments": "Payments",
    "profile": "My profile",
    "projects": "Projects",
    "reputation": "My reputation",
    "talent": "Find testers",
    "teamPanel": "Team panel",
    "teams": "Teams",
    "cv": "My CV",
    "adminErrors": "Errors",
    "membership": "Membership",
    "myMembership": "My membership",
    "memberships": "Memberships"
  },
  "shell": {
    "areas": "Workspace",
    "language": "Language",
    "logout": "Sign out",
    "mainNav": "Main navigation",
    "newOrg": "New organization",
    "openMenu": "Open menu",
    "organizations": "Organizations",
    "skipToContent": "Skip to content",
    "switchLanguage": "Change language",
    "switchOrg": "Switch organization",
    "theme": "Theme",
    "themeDark": "Dark",
    "themeFosforlu": "Highlighter",
    "themeLight": "Light",
    "themeOzalit": "Blueprint",
    "themeSystem": "System",
    "themeToggle": "Theme: {{mode}}",
    "userMenu": "User menu"
  },
  "area": {
    "admin": "Admin",
    "customer": "Customer",
    "lead": "Lead",
    "tester": "Tester"
  },
  "errors": {
    "conflict": "Someone else changed this record while you were editing. Reload the page and try again.",
    "forbidden": "You don't have permission to do this.",
    "loadFailed": "Could not load the data",
    "network": "The server could not be reached. Check your connection and that the API is running.",
    "notFound": "The record you are looking for was not found.",
    "notFoundTitle": "Not found",
    "pageNotFound": "Page not found",
    "pageNotFoundBody": "The link may be wrong, or the page may have moved.",
    "server": "An unexpected server error occurred. Please try again shortly.",
    "unknown": "An unknown error occurred."
  },
  "validation": {
    "email": "Enter a valid email address.",
    "minLength": "Enter at least {{n}} characters.",
    "number": "Enter a number.",
    "passwordLength": "The password must be at least 8 characters.",
    "range": "Enter a value between {{min}} and {{max}}.",
    "required": "This field is required.",
    "url": "Enter a valid address starting with http:// or https://.",
    "appLink": "Must be https://… or the app's own address (e.g. demoshop://open)."
  },
  "auth": {
    "devHint": "Development accounts:",
    "displayName": "Full name",
    "email": "Email",
    "haveAccount": "Already have an account?",
    "intent": "How will you use TestRome?",
    "intentHint": {
      "customer": "Write test cases, find testers, review recorded and scored results.",
      "tester": "Apply to jobs as a freelance tester, alone or with a team."
    },
    "intentOption": {
      "customer": "I want my app tested",
      "tester": "I want to earn by testing"
    },
    "login": "Sign in",
    "loginSubtitle": "Manage tests, recordings and evidence in one place.",
    "loginTitle": "Sign in to TestRome",
    "noAccount": "No account yet?",
    "password": "Password",
    "passwordHint": "At least 8 characters.",
    "register": "Create account",
    "registerSubtitle": "One account works as a customer, a community lead or a tester.",
    "registerTitle": "Create your account"
  },
  "invite": {
    "accept": "Accept invitation",
    "body": "{{inviter}} invited you to join {{community}} as {{role}}.",
    "invalid": "This invitation is invalid, expired or has reached its usage limit.",
    "joined": "You joined {{community}}.",
    "signInFirst": "Sign in or create an account to accept the invitation.",
    "title": "Community invitation"
  },
  "communityRole": {
    "Lead": "Lead",
    "Tester": "Tester"
  },
  "memberStatus": {
    "Active": "Active",
    "Invited": "Invited",
    "Removed": "Removed"
  },
  "orgRole": {
    "Admin": "Admin",
    "Owner": "Owner",
    "Reviewer": "Reviewer"
  },
  "welcome": {
    "browseJobs": "Browse jobs",
    "communityName": "Community name",
    "communityPlaceholder": "e.g. Mobile QA Crew",
    "createCommunity": "Create community",
    "createOrg": "Create organization",
    "createProfile": "Create my profile",
    "customerBody": "Upload your test cases, hand the work to a test community and inspect the recording of every run.",
    "customerTitle": "I want my app tested",
    "freelancerBody": "Create your profile, apply to jobs or take work from open pools. You earn for every accepted run and confirmed bug.",
    "freelancerTitle": "Become a freelance tester",
    "inviteLink": "Invitation link or code",
    "leadBody": "Build your own test team, invite members and pair with customers through a partner code.",
    "leadTitle": "I run a test community",
    "openInvite": "Open invitation",
    "orgName": "Organization name",
    "orgPlaceholder": "e.g. Acme Software",
    "subtitle": "How would you like to start? You can add the other roles at any time.",
    "testerBody": "Paste the invitation link you received from a community lead.",
    "testerTitle": "I'm joining as a tester",
    "title": "Welcome, {{name}}"
  },
  "org": {
    "create": "Create organization",
    "newSubtitle": "Your projects, test cases and teammates live under this organization.",
    "newTitle": "New organization"
  },
  "orgSettings": {
    "add": "Add",
    "addHint": "The person must already have a TestRome account.",
    "link": "Link",
    "linked": "{{name}} is now linked.",
    "linkedAt": "Linked {{at}}",
    "memberAdded": "{{name}} was added.",
    "memberCount_one": "{{count}} member",
    "memberCount_other": "{{count}} members",
    "members": "Team members",
    "membersHint": "Owners and admins manage projects and cycles; reviewers assess runs and bugs.",
    "noOrg": "You don't have an organization yet.",
    "noPartners": "No linked communities",
    "noPartnersBody": "Ask a community lead for their partner code and enter it here; the community then becomes available in your cycles.",
    "partnerCode": "Partner code",
    "partners": "Partner communities",
    "partnersHint": "External test communities that can run your tests.",
    "remove": "Remove",
    "removeBody": "This person will lose access to the organization's projects.",
    "removeTitle": "Remove {{name}} from the organization?",
    "role": "Role",
    "title": "Organization settings"
  },
  "platform": {
    "Android": "Android",
    "Ios": "iOS",
    "Web": "Web"
  },
  "projects": {
    "activeCycles": "Active cycles",
    "allowedOrigins": "Allowed origins",
    "allowedOriginsHint": "Addresses the recorder SDK may send data from (one per line). Empty means the app URL's origin.",
    "appUrl": "App URL",
    "appUrlHint": "The environment testers will open, e.g. https://staging.example.com",
    "create": "Create project",
    "emptyBody": "Create a project for the app you want tested.",
    "emptyTitle": "No projects yet",
    "name": "Project name",
    "new": "New project",
    "newDescription": "Next you will add the recorder SDK to your app.",
    "newTitle": "New project",
    "openBugs": "Open bugs",
    "pendingReviews": "Awaiting review",
    "platform": "Platform",
    "title": "Projects"
  },
  "projectNav": {
    "bugs": "Bugs",
    "cases": "Test cases",
    "cycles": "Test cycles",
    "knownIssues": "Known issues",
    "label": "Project sections",
    "logs": "Logs",
    "overview": "Overview",
    "project": "Project",
    "proposals": "Proposals",
    "quality": "Quality",
    "rhythm": "Work rhythm",
    "review": "Review",
    "settings": "Settings"
  },
  "overview": {
    "activeCycles": "Active cycles",
    "averageConfidence": "Average confidence",
    "confidence": "Confidence distribution",
    "confidenceHint": "Submitted runs by confidence band.",
    "executions_one": "{{count}} run",
    "executions_other": "{{count}} runs",
    "gettingStarted": "Getting started",
    "noScores": "No scored runs yet.",
    "openBugs": "Open bugs",
    "outcomes": "Outcomes",
    "pendingReviews": "Awaiting review",
    "recentCycles": "Recent cycles",
    "step1": "Add the SDK",
    "step1Body": "Add the recorder SDK to your app; it only records when a tester opens the app from TestRome.",
    "step2": "Upload test cases",
    "step2Body": "Write cases one by one or import them from CSV.",
    "step3": "Start the first cycle",
    "step3Body": "Pick cases, choose a community and distribute the assignments."
  },
  "cases": {
    "allSuites": "All suites",
    "anyPriority": "Any priority",
    "chooseFile": "Choose file",
    "csvContent": "CSV content",
    "csvHint": "A header row is required; rows sharing a case_key are the steps of one case.",
    "deleteSuiteBody": "Cases in the suite are kept, without a suite.",
    "deleteSuiteTitle": "Delete the \"{{name}}\" suite?",
    "editSuite": "Edit suite",
    "emptyBody": "Write your first case or import cases from a CSV file.",
    "emptyTitle": "No cases match this filter",
    "import": "Import CSV",
    "importDescription": "A preview runs first; if any row has an error, nothing is saved.",
    "importN_one": "Import {{count}} case",
    "importN_other": "Import {{count}} cases",
    "importTitle": "Import cases from CSV",
    "imported_one": "{{count}} case imported.",
    "imported_other": "{{count}} cases imported.",
    "key": "Key",
    "line": "Line {{line}}",
    "new": "New case",
    "newSuite": "New suite",
    "noSuitesBody": "Create a suite first to group your cases, e.g. \"Checkout\" or \"Sign-in\".",
    "noSuitesTitle": "No suites yet",
    "preview": "Preview",
    "previewCases_one": "{{count}} case read",
    "previewCases_other": "{{count}} cases read",
    "previewErrors_one": "{{count}} error",
    "previewErrors_other": "{{count}} errors",
    "priority": "Priority",
    "searchPlaceholder": "Search title or key…",
    "status": "Status",
    "statusFilter": "Status filter",
    "stepCount_one": "{{count}} step",
    "stepCount_other": "{{count}} steps",
    "steps": "Steps",
    "suiteName": "Suite name",
    "suites": "Suites",
    "targetSuite": "Target suite",
    "title": "Title",
    "updated": "Updated",
    "useExample": "Use the example CSV"
  },
  "caseStatus": {
    "Active": "Active",
    "Archived": "Archived",
    "Draft": "Draft",
    "Proposed": "Proposed",
    "Rejected": "Rejected"
  },
  "priority": {
    "Critical": "Critical",
    "High": "High",
    "Low": "Low",
    "Medium": "Medium"
  },
  "evidence": {
    "None": "Not required",
    "Screenshot": "Screenshot",
    "Video": "Video"
  },
  "checkpointType": {
    "Event": "Event",
    "None": "None",
    "Route": "Page route"
  },
  "caseEditor": {
    "action": "Action",
    "addStep": "Add step",
    "atLeastOneStep": "At least one step is required.",
    "checkpoint": "Checkpoint",
    "checkpointNoneHint": "The trace the app must produce when the step is really done.",
    "checkpointValue": "Checkpoint value",
    "created": "{{key}} created.",
    "createdBy": "Created by {{name}}",
    "deleteBody": "The case is archived; past runs and reports are kept.",
    "deleteTitle": "Delete {{key}}?",
    "dragStep": "Move step {{n}}",
    "duplicateStep": "Duplicate step",
    "eventHint": "The event name the app sends with checkpoint('…').",
    "evidence": "Evidence",
    "expected": "Expected result",
    "linkedIssues": "This case is linked to known issues:",
    "minSeconds": "Min time (s)",
    "newTitle": "New test case",
    "noSuite": "No suite",
    "preconditions": "Preconditions",
    "preconditionsPlaceholder": "e.g. A signed-in user with at least one item in the cart",
    "removeStep": "Remove step",
    "revision": "Revision {{n}}",
    "routeHint": "The page that must open at the end of the step, e.g. /checkout/success or /orders/:id",
    "routeMustStart": "The route must start with /.",
    "saved": "Case saved.",
    "steps": "Steps",
    "stepsHint": "Each step should hold one action and an observable expected result. Drag to reorder.",
    "suite": "Suite",
    "title": "Title"
  },
  "knownIssues": {
    "active": "Active",
    "activeLabel": "Active (the bug is still in the app)",
    "affectedCases_one": "{{count}} case",
    "affectedCases_other": "{{count}} cases",
    "deleteTitle": "Delete this known issue?",
    "dialogHint": "If a case affected by an active known issue is marked Passed, the run is treated as suspicious.",
    "edit": "Edit known issue",
    "emptyBody": "Add a bug you know is in the app: a tester who marks that case as passed may not have done the steps.",
    "emptyTitle": "No known issues",
    "inactive": "Inactive",
    "new": "Add known issue",
    "noCases": "No linked cases",
    "subtitle": "Deliberate canary checks: a test that cannot see a known bug may not have been run.",
    "title": "Known issues",
    "titleLabel": "Issue title"
  },
  "cycles": {
    "bugs": "Bugs",
    "community": "Community",
    "confidence": "Confidence",
    "due": "Due:",
    "empty": "No cycles yet.",
    "emptyBody": "A cycle hands selected cases to a community for a given build and time window.",
    "emptyTitle": "No test cycles yet",
    "name": "Cycle",
    "new": "New cycle",
    "notStarted": "Not started",
    "progress": "Progress",
    "status": "Status",
    "subtitle": "Each cycle is one build tested by one test team.",
    "title": "Test cycles"
  },
  "cycle": {
    "progressLabel": "{{done}} of {{total}} assignments done"
  },
  "cycleStatus": {
    "Active": "Active",
    "Closed": "Closed",
    "Draft": "Draft"
  },
  "distribution": {
    "EveryoneRunsAll": "Everyone runs every case",
    "NTestersPerCase": "N testers per case"
  },
  "deviceKind": {
    "Desktop": "Desktop",
    "Phone": "Phone",
    "Tablet": "Tablet"
  },
  "wizard": {
    "activateNote": "Activating creates the assignments and notifies testers; the case list can't change afterwards.",
    "activateNoteMarketplace": "When you publish, the job appears on the job board. The case list cannot be changed afterwards.",
    "activated_one": "Cycle started: {{count}} assignment created.",
    "activated_other": "Cycle started: {{count}} assignments created.",
    "activeCycles_one": "{{count}} active cycle",
    "activeCycles_other": "{{count}} active cycles",
    "addEnvironment": "Add environment",
    "allowExploratory": "Allow exploratory testing",
    "allowExploratoryHint": "Testers may open charter-based sessions beyond the cases, report bugs and propose new cases.",
    "any": "Any",
    "anyDevice": "Any device",
    "appVersion": "App version",
    "applyBy": "Applications close",
    "applyByOrder": "Applications must close before the due date.",
    "casesHint_one": "Choose from {{count}} active case.",
    "casesHint_other": "Choose from {{count}} active cases.",
    "casesSelected_one": "{{count}} case selected",
    "casesSelected_other": "{{count}} cases selected",
    "categories": "Category",
    "categoriesHint": "What kind of product is tested. The job is found on the job board under these categories. Pick up to 3.",
    "categoriesRequired": "Choose at least one category.",
    "claimHours": "Time to submit (hours)",
    "claimHoursHint": "Work not submitted in time goes back to the pool.",
    "communityHint": "Communities you lead and communities linked to your organization with a partner code.",
    "costEstimate": "Estimated maximum",
    "costEstimateHint": "runs and fixed fees incl. the {{fee}}% platform fee; bug bounties not included",
    "distribution": "Distribution",
    "distributionHint": {
      "Applications": "Every participant you accept runs every test case. For teams, assignments go to the lead, who hands them out.",
      "EveryoneRunsAll": "Every active tester in the community runs every selected case.",
      "NTestersPerCase": "Each case goes to N testers with the fewest assignments; the environment matrix is spread evenly.",
      "OpenPool": "The number of runs you set is opened for each test case; qualified testers take them one by one."
    },
    "draftSaved": "Draft saved.",
    "dueAfterStart": "The due date must be after the start.",
    "dueAt": "Due",
    "dueAtHint": "Assignments not started by then expire.",
    "editTitle": "Edit cycle",
    "envBrowser": "Browser",
    "envDevice": "Device",
    "envLabel": "Label",
    "envOs": "Operating system",
    "envUnique": "Environment labels must be unique.",
    "environments": "Environment matrix",
    "environmentsHint": "Which devices and browsers should the tests run on? Assignments are spread over these.",
    "escrow": "Payment guarantee",
    "escrowAmount": "Amount to set aside",
    "escrowBalance": "Available balance: {{available}}.",
    "escrowHint": "Set the budget aside from your balance and the listing shows “Payment secured”; accepted work is paid from it and what is left comes back when the job ends.",
    "escrowOn": "Set the budget aside from my balance",
    "escrowOnPublish": "set aside from your balance when published",
    "escrowShort": "not enough balance ({{available}} available); top up before publishing",
    "escrowTopUp": "Top up",
    "escrowUseEstimate": "Use estimate ({{amount}})",
    "estimate": "Assignments to create",
    "estimateOpen": "Depends on how many participants you accept",
    "estimateValue": "≈ {{count}}",
    "goToCases": "Go to cases",
    "instructions": "Notes for testers",
    "instructionsHint": "Test account details, out-of-scope areas, things to watch for…",
    "languages": "Languages",
    "languagesHint": "Comma separated: tr, en. Empty = any.",
    "listing": "Listing",
    "listingHint": "What testers see on the job board.",
    "maxOpenClaims": "Open assignments per person",
    "maxOpenClaimsHint": "So nobody hoards work.",
    "maxParticipants": "Places",
    "maxParticipantsHint": "Most participants you will accept (empty = no limit).",
    "members_one": "{{count}} member",
    "members_other": "{{count}} members",
    "minLevelHint": "For a team, one member at this level is enough.",
    "minReputation": "Minimum reputation",
    "moneyError": "Enter an amount like 1250 or 1250.50.",
    "name": "Cycle name",
    "namePlaceholder": "e.g. Release 2.4 acceptance",
    "noActiveCases": "This project has no active cases.",
    "noCommunities": "No communities available",
    "noCommunitiesBody": "Create a community, or link one with a partner code in the organization settings.",
    "noEnvironments": "No environments given; testers use their own devices.",
    "noEnvironmentsShort": "No environment constraint",
    "notDraft": "This cycle is no longer a draft and can't be edited.",
    "openBoard": "Open the cycle board",
    "ownCommunities": "Your communities",
    "pickCases": "Pick at least one case.",
    "pickCommunity": "Choose a community or a job type.",
    "price": {
      "bugCritical": "Critical bug",
      "bugMajor": "Major bug",
      "bugMinor": "Minor bug",
      "bugTrivial": "Trivial bug",
      "fixedFee": "Fixed fee (per participant)",
      "perAcceptedRun": "Per accepted run"
    },
    "pricing": "Pay",
    "pricingHint": "What the tester receives. A {{fee}}% platform fee is charged to you on top.",
    "pricingHintCommunity": "Optional: enter amounts if you pay community members ({{fee}}% platform fee added). Leave empty for unpaid work.",
    "pricingRequired": "Enter at least one amount for a job.",
    "published": "The job is live.",
    "rangeError": "Enter a valid number.",
    "recording": "Recording",
    "requireMatchingDevice": "Require a matching device",
    "requireMatchingDeviceHint": "The tester (or someone in the team) must own a device matching one of the environments.",
    "requirements": "Requirements",
    "requirementsHint": "Testers who do not meet them cannot apply or take work.",
    "reviewApplications": "Each participant runs all cases · {{count}} places",
    "reviewOpenPool": "Open pool · {{count}} runs per case",
    "runsPerCase": "Runs per test case",
    "saveAndActivate": "Save and start",
    "saveAndPublish": "Save and publish",
    "saveDraft": "Save as draft",
    "selectAll": "Select all",
    "sourceBody": {
      "Applications": "Post a job; freelance testers and teams apply, you choose.",
      "OpenPool": "Anyone who qualifies takes open slots, first come first served; no applications to wait for."
    },
    "sourceHint": "Give the work to your own community, or post it as a job for freelance testers.",
    "startsAt": "Start",
    "startsAtHint": "Leave empty to open the cycle as soon as it is started.",
    "step": {
      "basics": "Basics",
      "cases": "Cases",
      "community": "Testers",
      "distribution": "Distribution",
      "pricing": "Pay and requirements",
      "review": "Summary",
      "schedule": "Schedule"
    },
    "stepCount_one": "{{count}} step",
    "stepCount_other": "{{count}} steps",
    "steps": "Wizard steps",
    "subtitle": "Pick the cases, choose the test team and distribute the work.",
    "summary": "Job description",
    "summaryHint": "Public. The app address, instructions and test accounts are shown only to accepted participants.",
    "summaryPlaceholder": "e.g. We are looking for 4 people to test the mobile checkout on real iPhone and Android devices.",
    "targetUrl": "URL under test",
    "targetUrlHint": "Testers open the app from this address with their recording link.",
    "testersPerCase": "Testers per case",
    "testersPerCaseRange": "Must be between 1 and 50.",
    "title": "New test cycle",
    "visibility": "Who can see it",
    "visibilityHint": {
      "InviteOnly": "Only the people you invite can see and join it.",
      "Public": "Every tester sees the job."
    },
    "appLink": "App link",
    "appLinkHint": "The app's own address (e.g. demoshop://open) or an https link (store page, App Link). For SDK jobs the tester's phone opens the app with it.",
    "confidential": "Confidential job: non-disclosure agreement (NDA) and watermark",
    "confidentialHint": "Testers see the cases, instructions and the app's address only after accepting the agreement. The test screen, the app under test (with the SDK) and the review pages carry the viewer's name and code as a watermark.",
    "ndaText": "Agreement text",
    "ndaTextHint": "Leave it empty to use a ready text with your company's and the job's name. It cannot be changed after publishing.",
    "ndaPlaceholder": "Leave empty for the ready text.",
    "ndaShort": "The agreement needs at least 50 characters (or leave it empty).",
    "confidentialShort": "Confidentiality",
    "confidentialOwnText": "Confidential · your own agreement",
    "confidentialDefaultText": "Confidential · the ready agreement",
    "pricingHintNoFee": "What the tester receives. No commission is added on top.",
    "pricingHintCommunityNoFee": "Optional: enter amounts if you pay community members. Leave empty for unpaid work.",
    "costEstimateHintNoFee": "runs and fixed fees; bug bounties not included"
  },
  "board": {
    "activate": "Start cycle",
    "billing": "Payments",
    "boardTab": "Board",
    "charter": "Charter",
    "close": "Close cycle",
    "closeBody": "Assignments not started expire and running recordings stop. You can keep reviewing submitted runs.",
    "closeBodyEscrow": "Open assignments end. Accepted work is paid right away from this job's budget; what is left returns to your balance after 14 days (the dispute window).",
    "closeBodyPaid": "Open assignments expire. The fixed fee goes to participants with accepted runs; then create a statement on the Payments page.",
    "closeTitle": "Close this cycle?",
    "empty": "This cycle has no assignments yet.",
    "exploratory": "Exploratory sessions",
    "exploratoryHint": "Sessions testers opened beyond the cases.",
    "live": {
      "connected": "Live",
      "connecting": "Connecting…",
      "disconnected": "Not live",
      "reconnecting": "Reconnecting…"
    },
    "noExploratory": "No exploratory sessions yet.",
    "participantsTab": "Participants",
    "publish": "Publish",
    "questionsTab": "Questions",
    "receiving": "Recording right now",
    "report": "Report",
    "reviewQueue": "Review queue",
    "started": "Started",
    "state": "State",
    "tabs": "Cycle tabs",
    "target": "Target environment: {{env}}",
    "tester": "Tester",
    "viewListing": "View listing"
  },
  "assignmentStatus": {
    "Accepted": "Accepted",
    "Assigned": "Assigned",
    "Expired": "Expired",
    "InProgress": "In progress",
    "Rejected": "Rejected",
    "Submitted": "Submitted"
  },
  "executionStatus": {
    "Abandoned": "Abandoned",
    "InProgress": "In progress",
    "Submitted": "Submitted"
  },
  "executionKind": {
    "Exploratory": "Exploratory",
    "Scripted": "Scripted"
  },
  "outcome": {
    "Blocked": "Blocked",
    "Failed": "Failed",
    "Passed": "Passed",
    "none": "No outcome"
  },
  "stepStatus": {
    "Blocked": "Blocked",
    "Failed": "Failed",
    "NotRun": "Not run",
    "Passed": "Passed",
    "Skipped": "Skipped"
  },
  "reviewStatus": {
    "Accepted": "Accepted",
    "Pending": "Awaiting review",
    "Rejected": "Rejected"
  },
  "band": {
    "Check": "Check",
    "Suspicious": "Suspicious",
    "Trusted": "Trusted",
    "none": "No score",
    "pending": "Scoring"
  },
  "confidence": {
    "scoreAria": "Confidence score {{score}}, {{band}}"
  },
  "progress": {
    "accepted": "Accepted",
    "inProgress": "In progress",
    "rejected": "Rejected",
    "submitted": "Submitted"
  },
  "reason": {
    "CheckpointMissing": {
      "description": "The step's checkpoint (page route or event) did not appear in the recording during the step.",
      "title": "Checkpoint missing"
    },
    "CopiedText": {
      "description": "The actual-result text is nearly identical to another run's.",
      "title": "Copied text"
    },
    "DuplicateEvidence": {
      "description": "The same or a near-identical screenshot was used in another run.",
      "title": "Reused evidence"
    },
    "EnvironmentMismatch": {
      "description": "The declared device/OS/browser does not match what the SDK detected.",
      "title": "Environment mismatch"
    },
    "KnownIssuePassed": {
      "description": "A case affected by an active known issue was marked Passed.",
      "title": "Known issue not seen"
    },
    "NoInteraction": {
      "description": "No clicks or input in the app during the step.",
      "title": "No interaction"
    },
    "NoRecording": {
      "description": "No recording arrived from the app during the run.",
      "title": "No recording"
    },
    "StepTooFast": {
      "description": "The step was completed faster than the minimum time set in the case.",
      "title": "Too fast"
    },
    "NoVideo": {
      "description": "No video was uploaded on a screen-video job.",
      "title": "No screen recording"
    },
    "ShortVideo": {
      "description": "The screen recording is too short for the steps of the test.",
      "title": "Short video"
    },
    "DuplicateVideo": {
      "description": "The same video file was uploaded for another run too.",
      "title": "Same video"
    }
  },
  "reviewQueue": {
    "allCycles": "All cycles",
    "band": "Confidence band",
    "cycle": "Cycle",
    "emptyBody": "New submissions appear here, lowest score first.",
    "emptyTitle": "Nothing awaiting review",
    "execution": "Run",
    "outcome": "Outcome",
    "reasons": "Findings",
    "score": "Score",
    "submitted": "Submitted",
    "subtitle": "Submitted runs, most suspicious first.",
    "tester": "Tester",
    "title": "Review queue"
  },
  "review": {
    "accept": "Accept",
    "accepted": "Run accepted.",
    "actual": "Actual",
    "backToBoard": "Cycle board",
    "charter": "Charter",
    "checkpointMatched": "seen",
    "checkpointMissing": "not seen",
    "checkpointUnknown": "not evaluated",
    "confidence": "Confidence score",
    "decidedAs": "Decision: {{decision}}",
    "declared": "Declared environment",
    "detected": "Detected",
    "deviceTitle": "{{name}}'s device",
    "duration": "Step duration",
    "events": "Events ({{count}})",
    "expected": "Expected",
    "exploratoryHint": "Exploratory session: no steps. Review the notes, evidence and recording.",
    "filter": {
      "all": "All",
      "important": "Important"
    },
    "keys": {
      "accept": "Accept",
      "help": "Show shortcuts",
      "next": "Next run",
      "play": "Play / pause",
      "previous": "Previous run",
      "reject": "Reject (note required)",
      "steps": "Move between steps",
      "title": "Keyboard shortcuts"
    },
    "legendCheckpoint": "Checkpoint",
    "legendError": "Error",
    "legendNavigation": "Navigation",
    "loadingRecording": "Loading recording…",
    "next": "Next",
    "noDetection": "SDK not connected",
    "noDeviceDetails": "No detailed device information",
    "noDeviceDetailsHint": "Detailed device information (CPU, memory, graphics card…) is not available for this test.",
    "noEvents": "No events to show.",
    "noReasons": "No findings lowered the score.",
    "noRecordingBody": "The tester did not open the app through the TestRome link, or the SDK is not installed. Without a recording you cannot verify the steps were done.",
    "noRecordingTitle": "This run has no recording",
    "noVideoBody": "The tester did not upload a screen recording for this run.",
    "noVideoTitle": "No screen recording",
    "notDeclared": "Not declared",
    "notMarked": "not marked",
    "notSubmitted": "This run has not been submitted yet.",
    "note": "Review note",
    "notePlaceholder": "Note (optional)",
    "notes": "Notes",
    "pause": "Pause",
    "play": "Play",
    "previous": "Previous",
    "recordedByVideo": "Screen recording (no SDK)",
    "reject": "Reject",
    "rejectNotePlaceholder": "Say why you are rejecting; the tester sees this note.",
    "rejected": "Run rejected.",
    "replayFailed": "The recording could not be played.",
    "rescore": "Rescore",
    "scorePending": "Scoring in progress; this updates in a few seconds.",
    "screenVideo": "The tester's screen recording",
    "screenVideoMeta": "{{name}} · {{size}} · {{duration}}",
    "skipInactive": "Skip idle time",
    "speed": "Speed",
    "stepN": "Step {{n}}",
    "submittedAt": "Submitted {{at}}",
    "tabs": {
      "evidence": "Evidence",
      "label": "Review sections",
      "replay": "Recording",
      "steps": "Steps",
      "appFlow": "App flow"
    },
    "timeline": "Recording timeline",
    "videoSteps": "Where each step is in the video",
    "app": {
      "title": "Path through the app",
      "screens_one": "{{count}} screen",
      "screens_other": "{{count}} screens",
      "taps_one": "{{count}} tap",
      "taps_other": "{{count}} taps",
      "problems_one": "{{count}} error",
      "problems_other": "{{count}} errors",
      "crashed": "The app crashed",
      "beforeFirstScreen": "Before the first screen",
      "emptyTitle": "Nothing came from the app",
      "emptyBody": "The app never connected to this test (no QR code or pairing code was used), or the SDK is not in the app. The confidence score takes this into account."
    }
  },
  "bugs": {
    "allCycles": "All cycles",
    "allSeverities": "All severities",
    "allStatuses": "All statuses",
    "created": "Reported",
    "cycle": "Cycle",
    "emptyBody": "Bugs reported by testers are listed here.",
    "emptyTitle": "No bugs reported yet",
    "noMatchBody": "Change or clear the filters.",
    "noMatchTitle": "No matching bugs",
    "reporter": "Reporter",
    "searchPlaceholder": "Search bug titles…",
    "severity": "Severity",
    "status": "Status",
    "subtitle": "Reported bugs, each tied to its moment in the recording.",
    "title": "Bugs",
    "titleCol": "Title"
  },
  "severity": {
    "Critical": "Critical",
    "Major": "Major",
    "Minor": "Minor",
    "Trivial": "Trivial"
  },
  "bugStatus": {
    "Confirmed": "Confirmed",
    "Duplicate": "Duplicate",
    "Fixed": "Fixed",
    "New": "New",
    "Rejected": "Rejected"
  },
  "bugDetail": {
    "actual": "Actual result",
    "atStep": "Reported at step {{n}}",
    "attachments": "Attachments",
    "decision": "Decision",
    "duplicateHint": "Bugs with similar titles are listed; you can change the search.",
    "duplicateOf": "Duplicate of which bug?",
    "duplicates": "Duplicates ({{count}})",
    "environment": "Environment",
    "expected": "Expected result",
    "isDuplicate": "This bug duplicates another report:",
    "lastTriage": "Last triaged by {{name}}, {{at}}",
    "measured": "Measured device",
    "noCandidates": "No similar bugs found.",
    "noEnvironment": "No environment details",
    "note": "Note",
    "notePlaceholder": "A note for the reporter (optional)",
    "original": "Open the original",
    "reportedBy": "Reported by {{name}} · {{at}}",
    "saveTriage": "Save decision",
    "steps": "Steps to reproduce",
    "triage": "Triage",
    "triageHint": "Confirmed bugs earn the reporter reputation points.",
    "triageNote": "Triage note",
    "triaged": "Decision saved.",
    "watch": "Watch the recording",
    "watchAt": "Watch the recording at {{at}}"
  },
  "proposals": {
    "approve": "Approve",
    "approveHint": "An approved case becomes active and can be picked in later cycles.",
    "approveTitle": "Approve \"{{title}}\"?",
    "approved": "{{key}} approved and added to the active cases.",
    "by": "Proposed by {{name}}",
    "emptyBody": "Testers can propose new cases during exploratory testing; proposals wait for your approval here.",
    "emptyRejected": "No rejected proposals",
    "emptyTitle": "No pending proposals",
    "filter": "Proposal status",
    "noSuites": "Create a suite first.",
    "pending": "Pending",
    "reject": "Reject",
    "rejectNote": "Reason for rejection",
    "rejectNoteHint": "The tester who proposed it sees this note.",
    "rejectTitle": "Reject \"{{title}}\"?",
    "rejected": "Proposal rejected.",
    "rejectedTab": "Rejected",
    "rejectionNote": "Reason for rejection",
    "subtitle": "New test cases proposed by testers.",
    "title": "Case proposals"
  },
  "projectSettings": {
    "defaults": "Reset to defaults",
    "general": "General",
    "installMode": "Install method",
    "integration": "Recorder SDK",
    "integrationHint": "Added to your app once; it records nothing for your regular visitors.",
    "note1": "The SDK only activates when the page is opened through a TestRome link (#tp=…); regular users are unaffected.",
    "note2": "Password fields and sensitive inputs are masked in the recording.",
    "note3": "For event checkpoints, call checkpoint('name') after important actions.",
    "penalty": "Penalty",
    "perStep": "/ step",
    "publicKey": "Project key",
    "readOnly": "Only owners and admins can change these settings.",
    "retention": "Recording retention (days)",
    "retentionHint": "Session recordings older than this are deleted automatically.",
    "rotate": "Rotate key",
    "rotateBody": "Recordings sent with the old key are rejected. You also need to update the key in your app.",
    "rotateTitle": "Rotate the project key?",
    "rotated": "A new key was created.",
    "rule": "Rule",
    "scoring": "Confidence scoring rules",
    "scoringApplies": "Changes apply to new scores; use \"Rescore\" for existing runs.",
    "scoringHint": "The score starts at 100; each finding subtracts its penalty. 80+ trusted, 50–79 check, below 50 suspicious.",
    "scoringSaved": "Scoring rules saved.",
    "snippetCheckpoint": "When an important action completes (an \"Event\" checkpoint in a case):",
    "snippetInit": "At app start-up, before the first render:",
    "title": "Project settings",
    "androidNote1": "The SDK only records when the app is opened with the link TestRome gives (#tp=…) or when the tester types a pairing code; normal users are not affected.",
    "androidNote2": "It records screens, taps (the element's name only, never typed text), network requests, errors and crashes. Password fields are never read.",
    "androidNote3": "On the emulator the computer is 10.0.2.2; on a real phone use the computer's network address (start.command --lan).",
    "androidInit": "When the app starts (Application.onCreate):",
    "androidManifestComment": "The phone page's \"Open the app\" button opens the app with this link; put the same address in the job's \"App link\" field.",
    "iosNote1": "The SDK records only when the app is opened from a TestRome link or paired with a code; ordinary users are not affected.",
    "iosNote2": "Screens come from UIKit controller names (LoginViewController → /login); add .testRomeScreen(\"/profile\") to SwiftUI screens.",
    "iosNote3": "Typed text and passwords are not recorded; the tapped element's accessibilityIdentifier and visible label are.",
    "iosInit": "When the app starts (App init or didFinishLaunching)",
    "iosLink": "TestRome link (add the app's scheme under Info.plist → URL Types)"
  },
  "communities": {
    "activeCycles": "Active cycles",
    "emptyBody": "Start a test community, invite testers and pair with customers through a partner code.",
    "emptyTitle": "You're not in a community yet",
    "isPublic": "List as a freelance team",
    "isPublicHint": "Shown on the Teams page; testers can ask to join and you can take jobs for the team.",
    "members": "Members",
    "name": "Community name",
    "new": "New community",
    "newHint": "Whoever creates the community becomes its lead.",
    "publicBadge": "Public",
    "subtitle": "Test communities you belong to.",
    "title": "Communities"
  },
  "community": {
    "accepted": "Accepted",
    "activeCycles_one": "{{count}} active cycle",
    "activeCycles_other": "{{count}} active cycles",
    "activeMembers_one": "{{count}} active member",
    "activeMembers_other": "{{count}} active members",
    "approve": "Approve",
    "confirmedBugs": "Confirmed bugs",
    "copyLink": "Copy link",
    "createInvite": "Create invitation",
    "decline": "Decline",
    "details": "Community details",
    "devices": "Devices",
    "emptyUnlimited": "Empty = unlimited",
    "expired": "expired",
    "expires": "expires {{at}}",
    "expiresInDays": "Valid for (days)",
    "inviteCreated": "Invitation created and link copied to the clipboard.",
    "invitesTab": "Invitations",
    "joined": "joined {{at}}",
    "leaderboardTab": "Leaderboard",
    "logsTab": "Logs",
    "maxUses": "Usage limit",
    "member": "Member",
    "memberUpdated": "Member updated.",
    "membersTab": "Members",
    "newInvite": "New invitation link",
    "newInviteHint": "Anyone with the link can join until the limit is reached.",
    "noDevices": "No devices added",
    "noExpiry": "no expiry",
    "noInvites": "No active invitation links",
    "noLeaderboard": "Nobody has earned points yet",
    "noPartners": "No linked customers yet. Share your partner code with your customer.",
    "open": "Open",
    "partnerCode": "Partner code",
    "partnerCodeHint": "A customer enters this code in their organization settings to give your community work.",
    "partners": "Linked customers",
    "points": "Points",
    "regenerate": "Regenerate code",
    "regenerateBody": "The old code stops working; existing links are not affected.",
    "regenerateTitle": "Regenerate the partner code?",
    "reputation": "Reputation",
    "requestsHint": "People you approve join the team as testers.",
    "requests_one": "Join requests ({{count}})",
    "requests_other": "Join requests ({{count}})",
    "revoke": "Revoke",
    "revokeBody": "Nobody can join with this link any more.",
    "revokeTitle": "Revoke this invitation?",
    "role": "Role",
    "settingsTab": "Settings",
    "showRemoved": "Show removed ({{count}})",
    "status": "Status",
    "tabs": "Community sections",
    "uses": "{{uses}}/{{max}} uses",
    "workTab": "Team work"
  },
  "myAssignments": {
    "all": "All",
    "allDone": "Nothing left to do",
    "allDoneBody": "New assignments appear here when a cycle includes you.",
    "app": "App",
    "continue": "Continue",
    "done": "Done",
    "due": "Due {{at}}",
    "emptyBody": "Once you join a community and a cycle starts, your assignments are listed here.",
    "emptyTitle": "No assignments",
    "exploratory": "Exploratory",
    "filter": "Assignment filter",
    "findJobs": "Find new work →",
    "instructions": "Customer notes",
    "remaining_one": "{{count}} left",
    "remaining_other": "{{count}} left",
    "retry": "Run again",
    "reviewNote": "Review note",
    "start": "Start",
    "subtitle": "Test cases assigned to you, by cycle.",
    "target": "Target: {{env}}",
    "teamNote": "Note from the {{team}} lead",
    "title": "My assignments",
    "todo": "To do"
  },
  "runner": {
    "abandoned": "This run was abandoned.",
    "actual": "What did you see?",
    "actualHint": "(required for failed/blocked)",
    "actualPlaceholder": "Briefly describe what actually happened in the app…",
    "allDone": "All steps are done. Check them and submit.",
    "backToAssignments": "My assignments",
    "bug": {
      "attach": "Attach files",
      "contextAt": "Recording position: {{at}} · {{step}}",
      "created": "Bug #{{n}} reported.",
      "noStep": "no step",
      "recordingNote": "The bug is tied to this moment of the recording; the reviewer can watch from exactly there.",
      "submit": "Report bug",
      "title": "Report a bug",
      "titleLabel": "Short title",
      "titlePlaceholder": "e.g. Discount code does not change the total"
    },
    "cannotStart": "A new run can't be started for this assignment.",
    "continue": "Continue where you left off",
    "copyLink": "Copy link",
    "cycleNotActive": "This cycle is not active.",
    "devicesHint": "Save the devices you use often:",
    "elapsed": "Elapsed time",
    "environment": "Which device are you testing on?",
    "evidence": {
      "add": "Add screenshot / video",
      "paste": "or paste with Ctrl+V",
      "pasted": "Screenshot added.",
      "required": "{{kind}} required",
      "title": "Evidence",
      "tooLarge": "{{name}} is too large (max 25 MB)."
    },
    "keysHint": "Shortcuts: 1 Passed · 2 Failed · 3 Blocked · 4 Skip · N/P steps · B bug",
    "keysHintExploratory": "Shortcuts: B bug · Ctrl+V paste a screenshot",
    "native": {
      "notice": "This job is recorded by the TestRome SDK inside the {{platform}} app: screens, taps, network requests, errors and crashes. After you start, connect the app to this test with the QR code or a pairing code.",
      "openOnPhone": "Open on phone",
      "pairingCode": "Pairing code",
      "newCode": "New code",
      "typeCode": "Tap the TestRome button in the app and type this code:",
      "codeLabel": "Pairing code {{code}}",
      "codeValid": "Single use · valid until {{at}}",
      "codeExpired": "The code expired; get a new one.",
      "receivingHint": "The app is connected, {{count}} events received. Test on the phone and mark the results here.",
      "waitingHint": "Recording starts by itself once the app connects.",
      "stalledHint": "The last event came {{at}}. If the app closed, open it again; if it lost the connection, pair it again.",
      "howInstall": "Install the app under test on the phone or an emulator.",
      "howConnect": "Scan the QR code with “Open on phone”, or type the pairing code into the app's TestRome button.",
      "howSteps": "Test in the app; mark how each step went on this screen."
    },
    "openApp": "Open the app",
    "otherDevice": "Another device",
    "otherDeviceHint": "Testing on a phone or tablet (open it with the QR code)",
    "phone": {
      "fromPhone": "Upload from phone",
      "qrLabel": "QR code of the phone link",
      "videoHint": "Scan it with the phone's camera and pick the screen recording on the page that opens. No sign-in needed; the link only works for this test.",
      "appHint": "Scan it with the phone's camera and tap “Open the app”; the app connects to this test. No sign-in needed.",
      "validUntil": "Valid until {{at}}",
      "localOnly": "You opened this page at localhost, which a phone cannot reach. Start TestRome with start.command --lan and open it at the computer's network address.",
      "creating": "Preparing the link…",
      "videoArrived": "The screen recording arrived from the phone."
    },
    "problem": {
      "actualRequired": "Describe what you saw before marking the step failed or blocked.",
      "evidenceRequired": "This step needs a {{kind}}."
    },
    "propose": {
      "hint": "Turn what you found into a repeatable case; if the customer approves it, it joins the main cases and you earn reputation.",
      "sent": "Proposal sent ({{key}}).",
      "submit": "Send proposal",
      "title": "Propose a new case"
    },
    "proposeCase": "Propose case",
    "qr": "QR",
    "qrHint": "Scan with your phone's camera; the app opens with the recording link.",
    "recorded": "Recorded result: {{status}}",
    "recording": {
      "receiving": "Recording",
      "receivingHint_one": "The app is connected, {{count}} event received. Do the test in the app and mark the results here.",
      "receivingHint_other": "The app is connected, {{count}} events received. Do the test in the app and mark the results here.",
      "stalled": "Recording signal lost",
      "stalledHint": "Last event arrived {{at}}. If the app tab was closed, open it again.",
      "waiting": "The app is not connected yet",
      "waitingHint": "Open the app with the button on this screen; a tab you open yourself is not recorded."
    },
    "recordingNotice": "When you open the app from here your session is recorded (clicks, page changes, the screen). Password fields are masked. The recording is used only for this test.",
    "reportBug": "Bug",
    "start": "Start testing",
    "stepNav": "Steps",
    "stepOf": "Step {{n}} of {{total}}",
    "stepTime": "Time on this step",
    "stepsLeft_one": "{{count}} step left",
    "stepsLeft_other": "{{count}} steps left",
    "submit": {
      "confirm": "Submit",
      "done": "Submitted. Thank you!",
      "exploratoryHint": "Your notes and evidence will be sent for review.",
      "irreversible": "After submitting you can't change the results; recording stops.",
      "notes": "General notes",
      "notesPlaceholder": "Anything you want the reviewer to know?",
      "scriptedHint": "Your results and session recording will be sent for review.",
      "title": "Submit the run"
    },
    "submitAction": "Submit",
    "submitted": {
      "body": "Submitted on {{at}}.",
      "title": "Run submitted"
    },
    "targetHint": "The customer wants this assignment tested on {{env}}.",
    "thisBrowser": "This browser",
    "video": {
      "appLink": "Get / open the app",
      "clear": "Clear the marker of step {{order}}",
      "file": "Screen recording file",
      "goTo": "Go to where step {{order}} starts",
      "howExplore": "Open the app and explore; note what you find.",
      "howStart": "Start the phone's screen recording (iPhone: Control Centre → Screen Recording, Android: quick settings → Screen record) and press “I started recording”.",
      "howSteps": "Open the app, do the steps in order and mark each step here.",
      "howUpload": "When done, stop the recording and upload the video here (MP4, MOV or WebM, up to 500 MB).",
      "mark": "Mark steps",
      "markHint": "Play the video; when a step starts, press “Starts here” next to it. Reviewers jump straight to those moments.",
      "markTitle": "Where each step is in the video",
      "marked": "{{count}}/{{total}} steps marked in the video",
      "markersSaved": "Step markers saved.",
      "notMarked": "not marked",
      "notVideo": "{{name}} is not a video.",
      "notice": "This job is recorded with your phone's screen recording; the app has no SDK. Start the test, turn on screen recording, do the steps, then upload the video.",
      "player": "Screen recording",
      "ready": "Screen recording uploaded · {{duration}}",
      "replace": "Replace",
      "started": "I started recording",
      "startedAt": "Recording started {{at}}; where each step is in the video will be suggested from it.",
      "startsHere": "Starts here",
      "stepCovered": "The video of this step comes from the screen recording; no separate file needed.",
      "steps": "Steps",
      "title": "Testing with a screen recording",
      "tooLarge": "{{name}} is too large; up to 500 MB.",
      "upload": "Upload video",
      "uploaded": "Screen recording uploaded.",
      "uploading": "Uploading video",
      "uploadingPercent": "Uploading… {{percent}}%"
    }
  },
  "exploratory": {
    "charter": "Charter",
    "charterHint": "What will you explore, and from which angle? e.g. \"Cart: adding the same product in different variants\"",
    "charterPlaceholder": "What will you investigate in this session?",
    "cycle": "Cycle",
    "minutes_one": "{{count}} min",
    "minutes_other": "{{count}} min",
    "noCycles": "No cycles open for exploratory testing",
    "noCyclesBody": "When a customer allows exploratory testing in a cycle, you can start a session here.",
    "notes": "Session notes",
    "notesPlaceholder": "What did you try, what did you notice? Notes save automatically.",
    "overTime": "The planned time is up; wrap up and submit.",
    "saveFailed": "Could not save",
    "saved": "Saved",
    "saving": "Saving…",
    "start": "Start session",
    "subtitle": "Time-boxed, charter-driven testing beyond the scripted cases.",
    "timebox": "Time box",
    "title": "Exploratory session"
  },
  "myBugs": {
    "emptyBody": "Report bugs you find while testing with the Bug button on the test screen.",
    "emptyTitle": "You haven't reported any bugs yet",
    "subtitle": "Bugs you reported and the customer's decisions.",
    "title": "My bug reports"
  },
  "reputation": {
    "emptyBody": "Accepted runs and confirmed bugs earn points.",
    "emptyTitle": "No point changes yet",
    "history": "History",
    "rule": {
      "bugCritical": "Confirmed critical bug",
      "bugMajor": "Confirmed major bug",
      "bugMinor": "Confirmed minor bug",
      "bugRejected": "Rejected bug",
      "bugTrivial": "Confirmed trivial bug",
      "caseApproved": "Approved case proposal",
      "executionAccepted": "Accepted run",
      "executionRejected": "Rejected run"
    },
    "rules": "Point rules",
    "subtitle": "Community leads and customers take your reputation into account when assigning work.",
    "title": "My reputation",
    "total": "Total points"
  },
  "devices": {
    "add": "Add device",
    "added": "Device added.",
    "browser": "Browser",
    "emptyBody": "Add the devices you test on; assignments can be matched to them.",
    "emptyTitle": "No saved devices",
    "kind": "Device type",
    "model": "Model",
    "os": "Operating system",
    "osVersion": "Version",
    "removeBody": "The device is removed from your list; past runs are not affected.",
    "removeTitle": "Delete this device?",
    "save": "Save device",
    "subtitle": "The devices you test on, matched against a cycle's environment matrix.",
    "title": "My devices"
  },
  "attachments": {
    "open": "Open {{name}}"
  },
  "logs": {
    "action": {
      "account_updated": "updated their profile",
      "api_request": "made a request: {{method}} {{path}}",
      "assignment_expired": "closed an expired assignment: {{subject}} · {{user}}",
      "auth_registered": "signed up",
      "auth_signed_in": "signed in",
      "auth_signed_out": "signed out",
      "billing_info_updated": "updated billing details",
      "bug_attachment_added": "attached a file to a bug: {{fileName}} · {{subject}}",
      "bug_pushed": "sent a bug to {{tool}}: {{subject}} → {{externalKey}}",
      "bug_reported": "reported a bug: {{subject}} · {{severity}}",
      "bug_triaged": "changed bug status: {{subject}} → {{status}}",
      "case_created": "created test case {{subject}}",
      "case_deleted": "deleted test case {{subject}}",
      "case_imported": "imported {{count}} test cases from CSV",
      "case_updated": "edited test case {{subject}}",
      "community_created": "created community {{subject}}",
      "community_invite_created": "created an invite link: {{subject}} · {{role}}",
      "community_invite_revoked": "revoked an invite link: {{subject}}",
      "community_joined": "joined community {{subject}}",
      "community_member_updated": "updated community member: {{subject}} · {{role}} · {{memberStatus}}",
      "community_partner_code_regenerated": "regenerated the partner code: {{subject}}",
      "community_updated": "updated community details: {{subject}}",
      "consent_recorded": "recorded a privacy consent",
      "cv_imported": "filled in the CV from a PDF",
      "cv_updated": "updated their CV",
      "cycle_activated": "started test cycle {{subject}} · {{assignments}} assignments",
      "cycle_closed": "closed test cycle {{subject}}",
      "cycle_created": "created test cycle {{subject}}",
      "cycle_updated": "edited test cycle {{subject}}",
      "deposit_cancelled": "cancelled a top-up: {{deposit}}",
      "deposit_completed": "card top-up added: {{deposit}} · TRY {{amount}}",
      "deposit_confirmed": "confirmed a bank transfer top-up: {{deposit}} · TRY {{amount}}",
      "deposit_created": "started a top-up: {{deposit}} · TRY {{amount}}",
      "deposit_failed": "card top-up did not complete: {{deposit}}",
      "deposit_rejected": "declined a top-up: {{deposit}}",
      "device_added": "added a device: {{subject}}",
      "device_removed": "removed a device: {{subject}}",
      "escrow_released": "released the rest of a job's budget: {{subject}}",
      "escrow_reserved": "set budget aside for a job: {{subject}} · TRY {{amount}}",
      "evidence_uploaded": "uploaded evidence: {{fileName}} · {{subject}}",
      "execution_app_opened": "opened the app on the phone · {{subject}}",
      "execution_notes_saved": "saved test notes · {{subject}}",
      "execution_pairing_code_created": "got a pairing code for the app · {{subject}}",
      "execution_phone_link_created": "created a phone link (QR) · {{subject}}",
      "execution_relaunched": "reopened the run: {{subject}}",
      "execution_resumed": "resumed testing {{subject}}",
      "execution_scored": "scored confidence: {{subject}} · {{band}} {{score}}",
      "execution_started": "started testing {{subject}}",
      "execution_submitted": "submitted the run: {{outcome}} · {{subject}}",
      "execution_video_marked": "marked the steps in the video · {{subject}}",
      "execution_video_started": "started the screen recording · {{subject}}",
      "execution_video_uploaded": "uploaded a screen recording: {{fileName}} · {{subject}}",
      "exploratory_started": "started an exploratory session: {{subject}}",
      "fraud_reviewed": "decided on linked accounts",
      "integration_removed": "removed the {{tool}} integration",
      "integration_saved": "saved the {{tool}} integration",
      "integration_tested": "tested the {{tool}} connection",
      "job_application_accepted": "accepted the application: {{subject}}",
      "job_application_rejected": "rejected the application: {{subject}}",
      "job_applied": "applied to {{subject}} · {{unit}}",
      "job_claimed": "took work from the open pool: {{subject}} · {{testCase}}",
      "job_invite_accepted": "accepted the job invitation: {{subject}}",
      "job_invite_declined": "declined the job invitation: {{subject}}",
      "job_invited": "invited to the job: {{subject}}",
      "job_participant_removed": "removed a participant: {{subject}}",
      "job_withdrawn": "withdrew the application: {{subject}}",
      "known_issue_created": "added known issue {{subject}}",
      "known_issue_deleted": "deleted known issue {{subject}}",
      "known_issue_updated": "edited known issue {{subject}}",
      "legacy": "legacy entry: {{event}}",
      "organization_community_linked": "linked community: {{subject}}",
      "organization_created": "created organization {{subject}}",
      "organization_member_removed": "removed organization member: {{subject}}",
      "organization_member_set": "set organization member: {{subject}} · {{role}}",
      "payout_account_updated": "updated their payout account · {{payoutMethod}}",
      "payout_marked_paid": "recorded a payout to {{subject}} · {{amount}} TRY",
      "profile_updated": "updated their freelancer profile",
      "project_created": "created project {{subject}}",
      "project_key_rotated": "rotated the SDK key: {{subject}}",
      "project_scoring_updated": "changed confidence score weights: {{subject}}",
      "project_updated": "updated project settings: {{subject}}",
      "proposal_approved": "approved proposal {{subject}}",
      "proposal_rejected": "rejected proposal {{subject}}",
      "proposal_submitted": "proposed test case {{subject}}",
      "recording_device_details": "sent device details from the app (with consent) · {{subject}}",
      "recording_paired": "connected the app to the test with a pairing code · {{subject}}",
      "recording_started": "started recording in the app · {{subject}}",
      "recording_stopped": "stopped recording in the app · {{subject}}",
      "refund_rejected": "declined a balance refund: {{subject}}",
      "refund_requested": "asked for a balance refund: TRY {{amount}}",
      "refund_sent": "sent a balance refund: {{subject}} · TRY {{amount}}",
      "review_accepted": "accepted the run: {{subject}}",
      "review_rejected": "rejected the run: {{subject}}",
      "review_rescored": "recalculated the confidence score: {{subject}} · {{score}}",
      "statement_cancelled": "cancelled statement {{subject}}",
      "statement_created": "created statement {{subject}} · {{total}} TRY",
      "statement_marked_paid": "confirmed the bank transfer: {{subject}}",
      "statement_paid": "statement paid by card: {{subject}} · {{total}} TRY",
      "statement_paid_from_balance": "paid the statement from the balance: {{subject}}",
      "statement_payment_failed": "card payment did not complete: {{subject}}",
      "statement_payment_started": "started a card payment: {{subject}}",
      "statement_released": "retried the payout: {{subject}}",
      "step_completed": "finished step {{step}}: {{status}} · {{subject}}",
      "step_started": "started step {{step}} · {{subject}}",
      "suite_created": "created test group {{subject}}",
      "suite_deleted": "deleted test group {{subject}}",
      "suite_updated": "edited test group {{subject}}",
      "team_join_request_cancelled": "withdrew the join request: {{subject}}",
      "team_join_requested": "asked to join team {{subject}}",
      "team_offer_accepted": "accepted a team offer: {{subject}}",
      "team_offer_declined": "declined a team offer: {{subject}}",
      "team_offer_sent": "offered a place in the team: {{subject}} → {{user}}",
      "team_offer_withdrawn": "withdrew a team offer: {{subject}} → {{user}}",
      "team_shares_updated": "updated the team's earnings split: {{subject}}",
      "team_work_assigned": "handed out team work: {{subject}} → {{user}}",
      "team_work_bulk_assigned": "handed {{count}} team tasks to a member: {{subject}} → {{user}}",
      "team_work_distributed": "spread {{count}} team tasks over members: {{subject}}",
      "team_work_note_set": "wrote a note on a team task: {{subject}}",
      "tester_identity_set": "changed the identity verification: {{subject}}",
      "tester_qualification_set": "changed the academy status: {{subject}}",
      "user_reinstated": "reinstated the account: {{subject}}",
      "user_suspended": "suspended the account: {{subject}}",
      "promotion_purchased": "featured a listing: {{subject}} · {{promotion}} · {{days}} days",
      "promotion_paid": "featured listing paid by card: {{subject}} · {{promotion}} · TRY {{amount}}",
      "promotion_payment_failed": "featured listing payment did not complete: {{subject}} · {{promotion}}",
      "promotion_settings_updated": "updated featuring prices and monthly allowances",
      "promotion_cancelled": "stopped a featured listing: {{subject}} · {{promotion}}",
      "nda_accepted": "accepted the confidentiality agreement: {{subject}}",
      "test_account_created": "added a test account: {{subject}} · {{label}}",
      "test_account_updated": "changed a test account: {{label}}",
      "test_account_deleted": "deleted a test account: {{label}}",
      "test_account_released": "took back a test account: {{label}}",
      "test_account_claimed": "took a personal test account: {{subject}} · {{label}}",
      "test_account_revealed": "looked at a test account's password: {{subject}} · {{label}}",
      "invoice_issued": "invoice issued: {{invoice}} · ₺{{amount}}",
      "invoice_failed": "invoice could not be sent: {{invoice}}",
      "invoice_retried": "sent the invoice again: {{invoice}}",
      "invoice_cancelled": "cancelled the invoice: {{invoice}} · {{reason}}",
      "invoice_simulator_changed": "changed the invoice integrator simulation",
      "error_status_changed": "marked an error: {{error}}",
      "error_test_sent": "tested error tracking",
      "ci_token_created": "created a CI key: {{subject}} · {{token}}",
      "ci_token_revoked": "revoked a CI key: {{subject}} · {{token}}",
      "ci_run_started": "started a test run from CI: {{subject}} · {{build}}",
      "ci_run_cancelled": "stopped a CI test run: {{subject}}",
      "membership_checkout_started": "went to the membership payment: {{plan}} · {{interval}} · {{amount}} ₺",
      "membership_started": "membership started: {{plan}} · {{interval}} · {{amount}} ₺",
      "membership_renewed": "membership renewed",
      "membership_payment_failed": "membership payment received",
      "membership_replace_cancel_failed": "previous subscription cancelled: {{subscription}}",
      "membership_cancelled": "cancelled the membership",
      "membership_plan_changed": "changed the membership plan: {{plan}} · {{interval}}",
      "membership_expired": "membership ended",
      "membership_settings_updated": "updated membership settings: trial {{trialDays}} days, grace {{graceDays}} days, commission {{platformFeePercent}}%",
      "membership_plan_created": "added a membership plan: {{name}} · {{interval}} · {{price}} ₺",
      "membership_plan_updated": "updated a membership plan: {{name}}",
      "membership_admin_changed": "changed a membership: {{subject}}",
      "membership_simulator_changed": "changed the renewal simulation",
      "membership_renewal_simulated": "simulated a membership renewal"
    },
    "adminOnlyBody": "This page is for platform administrators.",
    "adminOnlyTitle": "Platform admins only",
    "adminSubtitle": "Every user's actions across all organizations and communities, including failed sign-ins.",
    "adminTitle": "All platform logs",
    "allCycles": "All cycles",
    "allProjects": "All projects",
    "allTypes": "All types",
    "anonymous": "Someone not signed in",
    "app": {
      "AppError": "App error: {{message}}",
      "AppWarning": "App warning: {{message}}",
      "Checkpoint": "Checkpoint: {{name}}",
      "Click": "clicked {{selector}}",
      "ClickText": "clicked “{{text}}”",
      "ConsoleError": "Console error: {{message}}",
      "ConsoleWarning": "Console warning: {{message}}",
      "Crash": "The app crashed: {{message}}",
      "Input": "typed into {{selector}}",
      "Navigation": "went to {{path}}",
      "NetworkError": "Network error: {{method}} {{url}} → {{status}}",
      "NetworkRequest": "{{method}} {{url}} → {{status}}",
      "Screen": "went to the {{path}} screen",
      "Tap": "tapped {{selector}}",
      "TapText": "tapped “{{text}}”",
      "background": "sent the app to the background",
      "foreground": "came back to the app",
      "hidden": "left the tab",
      "sessionStart": "recording session started",
      "sessionStop": "recording session ended",
      "visible": "came back to the tab"
    },
    "appType": {
      "Checkpoint": "Checkpoint",
      "Click": "Click",
      "ConsoleError": "Console error",
      "ConsoleWarning": "Console warning",
      "Input": "Input",
      "Navigation": "Page view",
      "NetworkError": "Network error",
      "NetworkRequest": "Network request",
      "Session": "Recording session",
      "VisibilityChange": "Tab visibility"
    },
    "category": {
      "account": "Account",
      "auth": "Sign-in / sign-up",
      "billing": "Payments",
      "bug": "Bugs",
      "community": "Community",
      "cycle": "Cycle",
      "design": "Test design",
      "execution": "Test runs",
      "marketplace": "Marketplace",
      "organization": "Organization",
      "other": "Other",
      "project": "Project",
      "review": "Review",
      "system": "System"
    },
    "clear": "Remove",
    "clearFilters": "Clear filters",
    "clearPerson": "Show everyone",
    "cycle": "Cycle",
    "dayCount_one": "{{count}} entry",
    "dayCount_other": "{{count}} entries",
    "detail": {
      "community": "Community",
      "data": "Data",
      "duration": "Duration",
      "error": "Error",
      "failed": "Failed",
      "ip": "IP address",
      "kind": "Action code",
      "ok": "Succeeded",
      "organization": "Organization",
      "request": "Request",
      "result": "Result",
      "time": "Time",
      "userAgent": "Browser"
    },
    "details": "Details",
    "emptyBody": "Entries appear here as people work in TestRome and tests are recorded.",
    "emptyTitle": "No logs yet",
    "end_one": "That's everything ({{count}} entry)",
    "end_other": "That's everything ({{count}} entries)",
    "errorBadge": "Error",
    "errorsCount_one": "{{count}} error",
    "errorsCount_other": "{{count}} errors",
    "errorsOnly": "Errors only",
    "everyone": "Everyone",
    "exported": "CSV downloaded.",
    "failed": "failed attempt: {{action}}",
    "failedAction": {
      "auth_registered": "failed to sign up",
      "auth_signed_in": "failed to sign in",
      "job_applied": "could not apply to {{subject}}",
      "job_claimed": "could not take work from {{subject}}",
      "statement_payment_failed": "card payment did not complete: {{subject}}",
      "membership_payment_failed": "membership payment failed",
      "membership_replace_cancel_failed": "the previous subscription could not be cancelled: {{subscription}}"
    },
    "failedBadge": "Failed",
    "findPerson": "Find a person",
    "lastSeen": "last active {{at}}",
    "live": "Live",
    "loadMore": "Older entries",
    "locale": "en-US",
    "managersOnlyBody": "You need the Owner or Admin role in this organization to see this page.",
    "managersOnlyTitle": "Only managers can see logs",
    "mySubtitle": "Everything you did in TestRome and the events recorded in the app during your tests. Customers and your community lead can see these too.",
    "myTitle": "My activity",
    "noActivity": "No activity in this range",
    "noMatchBody": "Loosen the filters or widen the time range.",
    "noMatchTitle": "No matching logs",
    "noPeople": "Nobody did anything in this range.",
    "noSubject": "(untitled)",
    "oneRun": "Single test run",
    "openRun": "Open run",
    "paymentProvider": "Payment provider",
    "people": "People",
    "person": "Person",
    "personCounts": "{{actions}} actions · {{events}} events · {{sessions}} runs",
    "personLogs": "Show this person's logs",
    "project": "Project",
    "range": "Time range",
    "ranges": {
      "1h": "Last hour",
      "24h": "Last 24 hours",
      "30d": "Last 30 days",
      "7d": "Last 7 days",
      "all": "All time"
    },
    "search": "Search logs",
    "searchPlaceholder": "Search: case, URL, error message, e-mail…",
    "source": {
      "all": "All",
      "app": "In the app",
      "platform": "TestRome"
    },
    "sourceHint": {
      "all": "TestRome actions and in-app events together",
      "app": "What testers did in the app under test: page views, clicks, console and network errors…",
      "platform": "What users did in TestRome: sign-ins, test steps, reviews, bug reports…"
    },
    "sourceLabel": "Source",
    "subtitle": "Everything people in your organization did in TestRome, and what testers did in the app under test, on one timeline.",
    "system": "System",
    "tile": {
      "actions": "TestRome actions",
      "errors": "Errors / failed",
      "events": "App events",
      "sessions": "Runs"
    },
    "title": "Who did what?",
    "type": "Type",
    "unitSolo": "solo",
    "unitTeam": "for a team",
    "unknownUser": "Unknown user",
    "viaPhone": "from phone",
    "watchMoment": "Watch this moment"
  },
  "sourcing": {
    "Applications": "Job with applications",
    "Community": "My community",
    "OpenPool": "Open pool"
  },
  "visibility": {
    "InviteOnly": "Invite only",
    "Public": "Public"
  },
  "participantStatus": {
    "Accepted": "Accepted",
    "Applied": "Applied",
    "Invited": "Invited",
    "Rejected": "Rejected",
    "Removed": "Removed",
    "Withdrawn": "Withdrawn"
  },
  "earningStatus": {
    "Invoiced": "Invoiced",
    "Paid": "Paid by customer",
    "PaidOut": "Paid out",
    "Pending": "Pending",
    "Void": "Void"
  },
  "statementStatus": {
    "Cancelled": "Cancelled",
    "Open": "Awaiting payment",
    "Paid": "Paid"
  },
  "payoutStatus": {
    "Failed": "Error",
    "NotSet": "Not set",
    "Ready": "Ready"
  },
  "payoutMethod": {
    "BankTransfer": "Bank transfer",
    "Iyzico": "Card payment provider (iyzico)",
    "None": "None"
  },
  "paymentMethod": {
    "Balance": "From balance",
    "BankTransfer": "Bank transfer",
    "Card": "Card"
  },
  "ineligible": {
    "Closed": "closed",
    "Deadline": "applications closed",
    "Device": "no matching device",
    "Full": "no places left",
    "Language": "language not spoken",
    "Level": "level too low",
    "NotInvited": "invite only",
    "Reputation": "reputation too low"
  },
  "market": {
    "allCategories": "All categories",
    "categories": "Categories",
    "categoryLimit": "{{count}} of {{max}} selected",
    "eligible": "You can take this job",
    "freelancers": "Freelance testers",
    "pay": {
      "bug": "{{amount}} per bug",
      "bugRange": "Bugs: {{min}}–{{max}}",
      "fixed": "Fixed {{amount}}",
      "perRun": "{{amount}} per run",
      "rowBug": "Confirmed bug ({{severity}})",
      "rowFixed": "Fixed fee (per participant)",
      "rowPerRun": "Per accepted run",
      "unpaid": "Unpaid",
      "firstReporter": "When the same bug is reported more than once, the bounty goes to the first reporter."
    },
    "solo": "Solo",
    "stats": {
      "acceptedRuns": "Accepted runs",
      "averageConfidence": "Average confidence",
      "confirmedBugs": "Confirmed bugs",
      "reputation": "Reputation"
    },
    "teamOf_one": "Team of {{count}}",
    "teamOf_other": "Team of {{count}}",
    "teams": "Teams"
  },
  "jobs": {
    "acceptInvite": "Accept invitation",
    "alert": "Notify me",
    "alertHint": "Get notified when a new job matching these filters is published",
    "alertManage": "Manage",
    "alertSaved": "Search saved. We will tell you about new matching jobs.",
    "all": "All",
    "boardTab": "Jobs",
    "cases_one": "{{count}} case",
    "cases_other": "{{count}} cases",
    "category": "Category",
    "createProfile": "Create my profile",
    "declineInvite": "Decline",
    "due": "Due {{at}}",
    "eligibleOnly": "Only jobs I qualify for",
    "emptyBody": "Loosen the filters or check back later. Keeping your languages and devices up to date qualifies you for more jobs.",
    "emptyTitle": "No matching jobs right now",
    "goToWork": "Go to my assignments",
    "inviteAccepted": "Invitation accepted. Your work is ready.",
    "mineEmptyBody": "Jobs you apply to or are invited to show up here.",
    "mineEmptyTitle": "No applications yet",
    "mineTab": "My applications",
    "noProfileBody": "A short profile is enough to apply and take work: a headline, skills and the languages you speak.",
    "noProfileTitle": "Create your freelancer profile first",
    "search": "Search jobs, projects or companies",
    "seatsLeft_one": "{{count}} place left",
    "seatsLeft_other": "{{count}} places left",
    "slotsLeft_one": "{{count}} open slot",
    "slotsLeft_other": "{{count}} open slots",
    "subtitle": "Testing jobs posted by customers. Apply or take work from an open pool; earn for every accepted run and confirmed bug.",
    "tabs": "Job tabs",
    "title": "Jobs",
    "type": "Job type",
    "typeHint": {
      "Applications": "You apply, the customer picks",
      "OpenPool": "Take work right away if you qualify"
    },
    "withdraw": "Withdraw application"
  },
  "jobDetail": {
    "about": "About the job",
    "accepted": "You were accepted. Your assignments are ready.",
    "anyEnvironment": "No environment requirement",
    "applied": "Application sent.",
    "apply": "Apply",
    "applyHint": "The customer reviews your application. If accepted, every case is assigned to you (to the lead for teams).",
    "applyTitle": "Apply to {{title}}",
    "as": "On behalf of",
    "asMe": "Myself",
    "asTeam": "Team {{name}} ({{count}} people)",
    "cases": "Test cases",
    "casesHint": "Titles are public; steps and the app address are shown only to accepted participants.",
    "claim": "Take work",
    "claimHint": "A test case is picked and assigned to you. If you do not submit within {{hours}} hours it goes back to the pool. At most {{max}} open assignments at a time.",
    "claimed": "{{key}} is yours. Due: {{at}}",
    "device": "Device",
    "deviceRequired": "You need a device matching one of the environments",
    "environments": "Environments",
    "exploratory": "Exploratory testing",
    "freeSlots_one": "{{count}} free",
    "freeSlots_other": "{{count}} free",
    "join": "Join",
    "message": "Note to the customer",
    "messageHint": "Which devices you will use and when you can start.",
    "messagePlaceholder": "e.g. I can start tomorrow with my iPhone 15 and Android phone.",
    "myRecord": "Your record",
    "openClaims_one": "You hold {{count}} open assignment.",
    "openClaims_other": "You hold {{count}} open assignments.",
    "pay": "Pay",
    "payHint": "What you earn. The platform fee is charged to the customer on top.",
    "requirements": "Requirements",
    "seats": "Places",
    "seatsOpen": "No limit ({{taken}} accepted)",
    "seatsValue_one": "{{count}} participant ({{taken}} accepted)",
    "seatsValue_other": "{{count}} participants ({{taken}} accepted)",
    "sendApplication": "Send application",
    "slots": "Open slots",
    "takeWork": "Take work",
    "teamHint": "You can also apply or take work for teams you lead.",
    "waiting": "Your application is waiting for the customer."
  },
  "profile": {
    "about": "About",
    "addSkill": "Add a skill",
    "bio": "About you",
    "categories": "Fields I work in",
    "categoriesHint": "What kind of products do you test? Customers filter testers by these fields.",
    "city": "City",
    "country": "Country",
    "create": "Create my profile",
    "createSubtitle": "Create a short profile and start applying to jobs right away.",
    "created": "Profile created. You can apply to jobs now.",
    "devicesNote": "Your devices are part of your profile and decide which jobs you qualify for:",
    "headline": "Headline",
    "headlineHint": "e.g. 5 years of testing mobile checkout flows",
    "isAvailable": "Open to new work",
    "isAvailableHint": "When off you are shown as “busy”.",
    "isListed": "Show me in the tester directory",
    "isListedHint": "When off, only customers of jobs you applied to and your team leads can see your profile.",
    "language": {
      "ar": "Arabic",
      "de": "German",
      "en": "English",
      "es": "Spanish",
      "fr": "French",
      "ru": "Russian",
      "tr": "Turkish"
    },
    "languages": "Languages",
    "noSkills": "No skills yet.",
    "skills": "Skills",
    "skillsHint": "Customers use these tags when they look for testers.",
    "subtitle": "Customers see you through this profile and invite you to their jobs.",
    "title": "My freelancer profile",
    "viewPublic": "My public profile",
    "visibility": "Visibility"
  },
  "earnings": {
    "account": "Payout account",
    "accountHint": "Your IBAN is stored encrypted. Your national ID is only forwarded to the payment provider and not kept by TestRome.",
    "accountSaved": "Payout account saved.",
    "accountTitle": "Payout account",
    "address": "Address",
    "amount": "Amount",
    "date": "Date",
    "email": "E-mail",
    "emptyBody": "Join a job:",
    "emptyTitle": "No earnings yet",
    "entries": "Activity",
    "entriesHint": "If a decision changes, nothing is deleted; an adjustment line is added.",
    "holderName": "Account holder's full name",
    "ibanKeep": "Saved IBAN ••{{last4}}. Enter a new one to change it.",
    "identityHint": "Required by the payment provider to open a sub-merchant account.",
    "identityNumber": "National ID (T.C. kimlik no)",
    "invoiced": "Invoiced",
    "invoicedHint": "Waiting for the customer's payment",
    "job": "Job",
    "method": "Payout method",
    "methodHint": {
      "BankTransfer": "After the customer pays, TestRome wires your earnings to this IBAN.",
      "Iyzico": "When the customer pays by card, your share goes straight to your IBAN through iyzico."
    },
    "noAccount": "Add a payout account to receive your earnings.",
    "paid": "Paid by customer",
    "paidHint": "To be sent to you",
    "paidOut": "Paid out",
    "paidOutHint": "Total sent to you",
    "payouts": "Paid out to you",
    "pending": "Pending",
    "pendingHint": "Not invoiced yet",
    "phone": "Mobile phone",
    "setAccount": "Add account",
    "status": "Status",
    "subtitle": "Accepted runs, confirmed bugs and fixed fees. When the customer pays the statement, your share is sent to your account.",
    "title": "Earnings",
    "what": "Description"
  },
  "teams": {
    "cancelRequest": "Withdraw request",
    "create": "Start a team",
    "emptyBody": "Start the first one.",
    "emptyTitle": "No public teams yet",
    "join": "Ask to join",
    "joinMessage": "Note to the lead",
    "joinMessageHint": "Mention your devices and experience.",
    "joinTitle": "Join {{name}}",
    "ledBy": "Lead: {{name}}",
    "members": "Members",
    "openMine": "Open my team",
    "requestSent": "Your request was sent to the lead.",
    "requested": "Request sent",
    "search": "Search teams",
    "sendRequest": "Send request",
    "subtitle": "Freelance testing teams. Join one and take jobs together; earnings are split by the shares the lead sets.",
    "title": "Teams",
    "memberCount": "Members",
    "minMembers": "At least",
    "maxMembers": "At most",
    "size": {
      "small": "1–5 people",
      "medium": "6–10 people",
      "large": "More than 10"
    },
    "clearSize": "Clear",
    "sortBy": "Sort",
    "sortName": "By name",
    "sortMembers": "By size (largest first)",
    "crossedRange": "The maximum cannot be smaller than the minimum.",
    "noMatchTitle": "No team matches",
    "noMatchBody": "Widen the member range or change the search.",
    "found_one": "{{count}} team",
    "found_other": "{{count}} teams",
    "mine_one": "My teams ({{count}})",
    "mine_other": "My teams ({{count}})",
    "mineHint": "You can be in several teams; on a job, though, you work alone or with just one of them.",
    "private": "Private community"
  },
  "testers": {
    "acceptance": "Acceptance rate",
    "anyDevice": "Any device",
    "availableOnly": "Available only",
    "busy": "Busy",
    "category": "Field",
    "device": "Device",
    "devices": "Devices",
    "emptyBody": "Change your search.",
    "emptyTitle": "No matching testers",
    "memberSince": "Member since {{at}}",
    "search": "Name, headline or city",
    "skill": "Skill (e.g. iOS)"
  },
  "talent": {
    "subtitle": "Browse freelance testers and teams. Invite them from a cycle's “Participants” tab.",
    "tabs": "Search tabs",
    "title": "Find testers"
  },
  "participants": {
    "accept": "Accept",
    "accepted": "{{name}} was accepted; assignments were created.",
    "alreadyIn": "Already in",
    "cancelInvite": "Cancel invitation",
    "cancelInviteTitle": "Cancel the invitation for {{name}}?",
    "emptyBody": {
      "Applications": "Applications show up here once the job is live. Invite testers if you do not want to wait.",
      "Community": "",
      "OpenPool": "The first tester to take work shows up here."
    },
    "emptyTitle": "No applications yet",
    "group": {
      "accepted": "Participants",
      "applied": "Applications",
      "invited": "Invited",
      "past": "Past"
    },
    "intro": {
      "Applications": "Review applications; every participant you accept gets all test cases (the lead, for teams).",
      "Community": "",
      "OpenPool": "Qualified testers take open slots themselves. You can still invite people or remove someone."
    },
    "invite": "Invite",
    "inviteHint": "The person or team joins the job when they accept.",
    "inviteKind": "Who to invite",
    "inviteMessage": "Message (optional)",
    "inviteMessagePlaceholder": "e.g. Your Android experience fits this job well.",
    "inviteTitle": "Invite to the job",
    "invited": "{{name}} was invited.",
    "lead": "Lead: {{name}}",
    "noResults": "No results.",
    "note": "Note: {{note}}",
    "reject": "Reject",
    "rejectNote": "Reason (optional)",
    "rejectNoteHint": "The applicant sees this note.",
    "rejectTitle": "Reject {{name}}?",
    "rejected": "Application rejected.",
    "remove": "Remove from job",
    "removeBody": "Assignments not started are withdrawn; runs in progress can still be submitted.",
    "removeTitle": "Remove {{name}} from the job?",
    "search": "Search by name or headline",
    "showPast": "Show past ({{count}})",
    "since": "{{at}}",
    "wasInvited": "came by invitation",
    "work": "{{assignments}} assignments · {{accepted}} accepted"
  },
  "billing": {
    "addInfo": "Add billing details",
    "code": "No.",
    "createStatement": "Create statement",
    "created": "Statement {{code}} created.",
    "cycle": "Cycle",
    "date": "Date",
    "entries": "Items",
    "fee": "Platform fee",
    "field": {
      "address": "Address",
      "city": "City",
      "companyName": "Company name",
      "contactName": "Contact first name",
      "contactSurname": "Contact last name",
      "country": "Country",
      "email": "E-mail",
      "identityNumber": "Contact's national ID",
      "phone": "Phone",
      "taxNumber": "Tax number",
      "taxOffice": "Tax office"
    },
    "identityHint": "Required by the payment provider for card payments.",
    "infoHint": "Statements are issued with these details. Paying by card needs the contact person's national ID.",
    "infoTitle": "Billing details",
    "managersOnly": "Only organization owners and admins can see payments.",
    "markPaid": "Mark as paid",
    "markPaidTitle": "Confirm the bank transfer",
    "markPaidTitleCode": "Mark {{code}} as paid",
    "markedPaid": "Statement marked as paid.",
    "noInfoBody": "Add your billing details before creating a statement.",
    "noInfoTitle": "Billing details missing",
    "noStatements": "No statements yet.",
    "nothingToBill": "Nothing to invoice.",
    "paymentFailed": "The payment did not go through. Try again or pay by bank transfer.",
    "reference": "Reference",
    "referenceHint": "Bank receipt number or note.",
    "statements": "Statements",
    "status": "Status",
    "subtitle": "What testers are owed, and statements",
    "testers": "To testers",
    "title": "Payments",
    "total": "Total",
    "unbilled": "Work not yet invoiced",
    "unbilledHint": "Runs you accepted, bugs you confirmed and fixed fees of closed jobs. Create a statement to pay them."
  },
  "statement": {
    "accountName": "Beneficiary",
    "amount": "Amount",
    "balanceFromAvailable": "Paid from your available balance ({{available}}).",
    "balanceFromReserve": "Paid entirely from this job's budget.",
    "balanceShort": "Not enough balance: {{available}} available, {{held}} set aside for this job.",
    "balanceSplit": "{{reserve}} comes from this job's budget and {{rest}} from your available balance.",
    "bank": "Bank",
    "blocker": {
      "billingMissing": "The contact person's national ID is missing from billing details.",
      "notConfigured": "Card payments are not enabled in this installation.",
      "notOpen": "The statement is not open for payment.",
      "payeesNotReady": "Some testers have no card payout account; pay by bank transfer."
    },
    "cancel": "Cancel statement",
    "cancelBody": "The items become “not invoiced” again and you can create a new statement later.",
    "cancelTitle": "Cancel {{code}}?",
    "cancelledBody": "This statement was cancelled; its items can be invoiced again.",
    "cardBody": "You are taken to the payment page. Each tester's share goes to their own account; the platform fee stays with TestRome.",
    "cardReady": "Paid out by card provider",
    "entries": "Items",
    "entriesHint": "Every run, bug and fixed fee in this statement.",
    "fee": "Platform fee ({{percent}}%)",
    "lines": "Who gets what",
    "paidBalanceBody": "Paid from your balance; TestRome sends the testers their share.",
    "paidCardBody": "Shares were sent to the testers' accounts.",
    "paidFromBalance": "Statement paid from your balance.",
    "paidOn": "Paid · {{method}}",
    "paidTransferBody": "TestRome sends the testers their share.",
    "payByCard": "Pay by card",
    "payByTransfer": "Pay by bank transfer",
    "payFromBalance": "Pay from balance",
    "payFromBalanceNow": "Pay from balance",
    "payNow": "Pay by card",
    "payee": "Tester",
    "payeeAmount": "Amount",
    "payment": "Payment",
    "paymentSuccess": "Payment received. Thank you!",
    "payout": "Payout",
    "reference": "Description",
    "release": "Retry payout",
    "released": "Paid out",
    "subtotal": "To testers",
    "subtotalHint": "Goes entirely to the testers",
    "title": "Statement {{code}}",
    "topUp": "Top up",
    "total": "Total due",
    "transferBody": "Put the statement number in the description. Testers are paid once your payment is confirmed.",
    "transferOnly": "Paid out by transfer"
  },
  "adminBilling": {
    "account": "Account",
    "awaiting": "Statements awaiting bank transfer",
    "awaitingHint": "Check the incoming payment on the bank account, then mark it.",
    "markPaidOut": "Paid out",
    "noAccount": "No payout account",
    "noPayouts": "Nothing to pay out.",
    "noneAwaiting": "Nothing awaiting.",
    "paidOut": "Payout recorded.",
    "payoutTitle": "Confirm the payout to {{name}}",
    "payouts": "Payouts due to testers",
    "payoutsHint": "Earnings the customer paid and that were not sent yet. Mark them after making the transfer.",
    "recent": "Recently paid statements",
    "subtitle": "Bank transfers to confirm and payouts to testers",
    "title": "Payments"
  },
  "teamWork": {
    "assigned": "{{key}} → {{name}}",
    "case": "Test case",
    "equal": "equal",
    "equalSplit_one": "Equal among {{count}} member",
    "equalSplit_other": "Equal among {{count}} members",
    "holder": "Assigned to",
    "holderOf": "{{key}} assigned to",
    "items": "Team assignments",
    "itemsHint": "When the team is accepted to a job, assignments come to you first. Hand out the ones not started yet.",
    "job": "Job",
    "jobs": "Team jobs",
    "noItems": "The team has no open assignments",
    "noItemsBody": "Apply to a job for your team or take work from an open pool:",
    "noJobs": "The team has not applied to a job yet.",
    "shareOf": "Share of {{name}}",
    "shares": "Earnings split",
    "sharesHint": "Every team earning is split among members by these shares. Leave them empty to split equally.",
    "sharesSaved": "Shares saved.",
    "status": "Status",
    "total": "Total {{total}}% (must be 100)"
  },
  "jobCategory": {
    "Api": "API & backend",
    "DesktopApp": "Desktop app",
    "Game": "Game",
    "MobileApp": "Mobile app",
    "Other": "Other",
    "SmartDevice": "TV, watch & smart devices",
    "WebApp": "Web app"
  },
  "notifications": {
    "alertDelete": "Delete search",
    "alertEligible": "only jobs I qualify for",
    "alertLast": "Last match {{at}}",
    "alertNever": "No match yet",
    "alertsCreate": "Go to jobs",
    "alertsEmpty": "No saved searches.",
    "alertsHint": "You are notified when a new job matching these is published. Pick filters on the job board and press “Notify me”.",
    "alertsTitle": "Saved searches",
    "all": "All",
    "bell": "Notifications",
    "bellUnread": "Notifications ({{count}} unread)",
    "emailEnabled": "Also send notifications by e-mail",
    "emailHint": "Notifications are also sent to {{email}}. Notifications you already read in the app are not e-mailed; several are combined into one e-mail.",
    "emailOff": "E-mail is not enabled in this installation; notifications only show in the app.",
    "emailTitle": "E-mail",
    "empty": "No notifications yet",
    "emptyBody": "Updates about your work show up here.",
    "filter": "Show",
    "group": {
      "jobs": "Jobs and applications",
      "messages": "Messages",
      "payments": "Payments",
      "reviews": "Reviews and disputes",
      "teams": "Teams",
      "work": "Assignments and run results"
    },
    "groupHint": {
      "jobs": "Application decisions, invitations, new jobs matching your saved searches",
      "messages": "Messages between customers and testers",
      "payments": "Statement payments and payouts",
      "reviews": "Ratings you receive, dispute outcomes",
      "teams": "Join requests and approvals",
      "work": "New assignments, deadlines, run and bug decisions"
    },
    "groupsLegend": "E-mail me about",
    "inAppAlways": "In-app notifications are always on.",
    "kind": {
      "account_reinstated": "Your account was reinstated",
      "account_suspended": "Your account was suspended. Reason: {{reason}}",
      "job_alert": "New job matching your saved search: {{cycle}} ({{org}})",
      "job_application_accepted": "Your application was accepted: {{cycle}}. Your assignments are ready.",
      "job_application_received": "{{name}} applied to your job: {{cycle}}",
      "job_application_received_team": "Team {{team}} ({{name}}) applied to your job: {{cycle}}",
      "job_application_rejected": "Your application was not accepted: {{cycle}}",
      "job_invite_answered_false": "{{name}} declined your invitation: {{cycle}}",
      "job_invite_answered_true": "{{name}} accepted your invitation: {{cycle}}",
      "job_invited": "{{org}} invited you to a job: {{cycle}}",
      "job_invited_team": "{{org}} invited team {{team}} to a job: {{cycle}}",
      "job_removed": "The customer removed you from the job: {{cycle}}",
      "messages_question_answered": "Your question was answered: {{cycle}}",
      "messages_question_asked": "{{name}} asked a question on your listing: {{cycle}}",
      "messages_received": "{{name}} wrote to you ({{cycle}}): {{preview}}",
      "payments_deposit_awaiting": "{{org}} announced a {{amount}} top-up ({{code}}); confirm the bank transfer",
      "payments_deposit_completed": "{{amount}} was added to your balance ({{code}})",
      "payments_deposit_rejected": "Top-up {{code}} was not confirmed",
      "payments_earnings_paid": "The customer paid {{cycle}}: {{amount}} is yours",
      "payments_escrow_released": "The unused {{amount}} set aside for {{cycle}} is back in your balance",
      "payments_payout_sent": "{{amount}} was sent to your account",
      "payments_refund_decided_Rejected": "Your {{amount}} refund request was declined; the amount is back in your balance",
      "payments_refund_decided_Sent": "Your {{amount}} refund was sent",
      "payments_refund_requested": "{{org}} asked for a {{amount}} refund from its balance",
      "payments_transfer_awaiting": "{{org}} created statement {{code}} ({{amount}}); a bank transfer may follow",
      "reviews_dispute_escalated": "The dispute on {{subject}} went to a platform admin",
      "reviews_dispute_opened": "{{name}} disputed the decision on {{subject}}",
      "reviews_dispute_resolved_Overturned": "The platform overturned the decision on {{subject}}",
      "reviews_dispute_resolved_ResolvedByCustomer": "The customer changed the decision on {{subject}}",
      "reviews_dispute_resolved_Upheld": "The platform upheld the decision on {{subject}}",
      "reviews_received": "You received a {{rating}}-star review for {{cycle}}",
      "team_join_approved": "You joined {{team}}",
      "team_join_requested": "{{name}} asked to join {{team}}",
      "team_offer_answered_false": "{{name}} declined your offer to join {{team}}",
      "team_offer_answered_true": "{{name}} accepted your offer to join {{team}}",
      "team_offer_received": "{{name}} invites you to join {{team}}",
      "work_assigned_case": "{{case}} was handed to you: {{cycle}}",
      "work_assigned_one": "{{count}} new assignment: {{cycle}}",
      "work_assigned_other": "{{count}} new assignments: {{cycle}}",
      "work_bug_triaged": "Bug #{{bug}}: {{status}} ({{title}})",
      "work_due_soon": "{{case}} is due soon: {{cycle}} (due {{due}})",
      "work_qualified": "You passed the TestRome academy; you can now reach Silver and above",
      "work_run_reviewed_Accepted": "Your {{case}} run was accepted: {{cycle}}",
      "work_run_reviewed_Rejected": "Your {{case}} run was rejected: {{cycle}}",
      "system_error_reported": "New error: {{kind}} — {{message}}",
      "system_error_regressed": "An error marked resolved happened again: {{kind}} — {{message}}",
      "account_membership_trial_ending": "{{days}} day(s) left in your TestRome trial; choose a plan to keep working",
      "account_membership_trial_ending_org": "{{days}} day(s) left in the trial of {{org}}; choose a plan to keep working",
      "account_membership_payment_failed": "Your membership renewal could not be charged: {{error}}",
      "account_membership_payment_failed_org": "The membership renewal of {{org}} could not be charged: {{error}}",
      "account_membership_expired": "Your membership ended; renew it to apply to new marketplace jobs",
      "account_membership_expired_org": "The membership of {{org}} ended; data stays, but no new work can be started"
    },
    "markAll": "Mark all as read",
    "more": "Load more",
    "noUnread": "No unread notifications",
    "open": "Open",
    "seeAll": "All notifications",
    "subtitle": "What happened with your jobs, runs and payments.",
    "tabAll": "Notifications",
    "tabSettings": "Settings",
    "tabs": "Notification tabs",
    "title": "Notifications",
    "unread": "unread",
    "unreadCount": "Unread ({{count}})"
  },
  "feedback": {
    "comment": "Comment (optional)",
    "commentHint": "Shown publicly. Do not include personal details.",
    "customerGaveYou": "Customer's rating:",
    "customerReviews": "Reviews of {{name}}",
    "customerShort": "Customer",
    "noRating": "No ratings yet",
    "noReviews": "No reviews yet.",
    "pickStars": "Pick a rating.",
    "rate": "Rate",
    "rateCustomer": "Rate the customer",
    "rateCustomerHint": "Were the instructions clear, the decisions fair, the payment on time? Your rating guides other testers.",
    "rateCustomerTitle": "Rate {{name}}",
    "rateHint": "Quality of work, communication and thoroughness. Your rating appears on the participant's profile.",
    "rateTitle": "Rate {{name}}",
    "ratingTitle": "Average {{avg}} from {{count}} reviews",
    "reviewsTitle": "Reviews",
    "saved": "Review saved.",
    "send": "Send",
    "starWord": {
      "1": "Poor",
      "2": "Weak",
      "3": "Okay",
      "4": "Good",
      "5": "Excellent"
    },
    "stars": "Rating",
    "starsLabel": "{{value}} out of 5 stars",
    "starsOption_one": "{{count}} star",
    "starsOption_other": "{{count}} stars",
    "theirRating": "Their rating of you:",
    "youGaveCustomer": "Your rating:",
    "yourRating": "Your rating:"
  },
  "disputeStatus": {
    "Escalated": "Platform is reviewing",
    "Open": "Waiting for the customer",
    "Overturned": "Decision overturned",
    "ResolvedByCustomer": "Customer changed the decision",
    "Upheld": "Decision upheld",
    "Withdrawn": "Withdrawn"
  },
  "disputes": {
    "active": "Open ({{count}})",
    "adminEmpty": "No disputes waiting for a decision.",
    "adminSubtitle": "Decisions the customer stood by. Read both sides and decide.",
    "adminTitle": "Disputes",
    "all": "All ({{count}})",
    "customerResponse": "Customer's reply",
    "decided": "Decision saved.",
    "decision": {
      "Duplicate": "Duplicate",
      "Rejected": "Rejected"
    },
    "decisionNote": "Customer's note",
    "decisionWas": "Decision: {{decision}}",
    "escalated": "The dispute was sent to the platform.",
    "filter": "Show",
    "keep": "Stand by my decision",
    "keepBody": "Explain your decision. The dispute goes to a platform admin, whose decision is final.",
    "keepTitle": "{{subject}}: keep the decision",
    "kind": {
      "Bug": "Bug",
      "Run": "Run"
    },
    "label": "Dispute",
    "myEmpty": "You can dispute a rejected run or bug from “My assignments” and “My bugs”.",
    "mySubtitle": "Disputes you opened over rejected runs and bugs.",
    "myTitle": "My disputes",
    "none": "No disputes",
    "noneActive": "No open disputes",
    "note": "Decision note",
    "noteRequired": "Write a note.",
    "open": "Dispute",
    "openHint": "The customer may change the decision or explain it; then the platform decides. A decision can be disputed once (within 14 days).",
    "openTitle": "Dispute the decision on {{subject}}",
    "opened": "Your dispute was sent to the customer.",
    "orgEmpty": "Disputes over your decisions show up here.",
    "orgSubtitle": "Testers disputing your decisions. Change the decision or explain it.",
    "orgTitle": "Disputes",
    "overturn": "Overturn (accept)",
    "overturnBody": "The run is accepted (the bug confirmed). Earnings and reputation are updated; both sides are notified.",
    "overturnTitle": "{{subject}}: overturn",
    "platformDecision": "Platform decision",
    "reason": "Reason",
    "reasonHint": "Say briefly what was judged wrong and where the evidence is.",
    "reasonLabel": "Dispute",
    "reasonRequired": "Write the reason.",
    "reply": "Reason",
    "replyOptional": "Note to the tester (optional)",
    "reverse": "Change decision",
    "reverseBody": "The run is accepted (the bug confirmed); earnings and reputation are updated.",
    "reverseTitle": "{{subject}}: change the decision",
    "reversed": "Decision changed.",
    "reviewersOnly": "Only owners, admins and reviewers of the organization can see disputes.",
    "send": "Send dispute",
    "uphold": "Uphold",
    "upholdBody": "The customer's decision stands. Both sides are notified.",
    "upholdTitle": "{{subject}}: uphold",
    "withPlatform": "A platform admin is reviewing this dispute.",
    "withdraw": "Withdraw dispute",
    "withdrawBody": "You cannot dispute the same decision again.",
    "withdrawTitle": "Withdraw the dispute?",
    "withdrawn": "Dispute withdrawn."
  },
  "messages": {
    "back": "Back to conversations",
    "conversations": "Conversations",
    "emptyBody": "Start one with a job's participant or customer using the “Message” button.",
    "emptyTitle": "No conversations yet",
    "linkUnread": "Messages ({{count}} unread conversations)",
    "noMessagesYet": "No messages yet",
    "pick": "Pick a conversation on the left.",
    "placeholder": "Your message… (Ctrl+Enter to send)",
    "send": "Send",
    "startHint": "Write the first message. The other side is notified.",
    "subtitle": "Conversations with customers and the testers working on their jobs.",
    "title": "Messages",
    "unread": "{{count}} unread",
    "write": "Message",
    "writeCustomer": "Message the customer"
  },
  "questions": {
    "answer": "Answer",
    "answerLabel": "Answer: {{question}}",
    "answerPlaceholder": "Your answer…",
    "answered": "Answer saved.",
    "answeredBy": "Answered by {{name}}",
    "ask": "Ask",
    "askHint": "Do not share personal details or passwords; message the customer privately once you join.",
    "askPlaceholder": "e.g. Is the test account shared?",
    "delete": "Delete question",
    "hint": "Ask about the job; answers are public.",
    "none": "No answered questions yet.",
    "noneCustomer": "No questions yet",
    "noneCustomerBody": "Testers' questions about your listing show up here.",
    "private": "Private",
    "publicLabel": "Public answer",
    "sent": "Your question was sent to the customer.",
    "title": "Questions",
    "waiting": "waiting for an answer"
  },
  "escrow": {
    "add": "Add budget",
    "addHint": "Your available balance is {{available}}. The amount is only used for this job's statements.",
    "addTitle": "Add budget to this job",
    "added": "{{amount}} set aside for this job.",
    "amount": "Amount",
    "amountInvalid": "Enter a valid amount (at most 2 decimals).",
    "autoRelease": "What is left returns to your balance on {{date}}.",
    "badge": "Payment secured",
    "badgeAmount": "Payment secured · {{amount}}",
    "badgeHint": "The customer has set the budget aside for this job; accepted work is paid from it.",
    "blocker": {
      "active": "The job is still live",
      "disputes": "A dispute is open",
      "unreviewed": "Runs await review",
      "untriaged": "Bugs await triage"
    },
    "boardDone": "The budget set aside for this job has been used or released.",
    "boardHeld": "Payment secured: {{amount}} is set aside for this job.",
    "boardNone": "No budget has been set aside for this job.",
    "boardPlanned": "{{amount}} will be set aside from your balance when the job is published.",
    "release": "Release the rest",
    "releaseBody": "Unpaid statements are paid from this budget first ({{owed}}); the remaining {{amount}} returns to your available balance.",
    "releaseTitle": "Return the remaining budget to your balance?",
    "released": "The remaining budget is back in your balance."
  },
  "depositStatus": {
    "Cancelled": "Cancelled",
    "Completed": "Added",
    "Failed": "Failed",
    "Pending": "Pending"
  },
  "refundStatus": {
    "Rejected": "Declined",
    "Requested": "Requested",
    "Sent": "Sent"
  },
  "walletEntry": {
    "Deposit": "Top-up {{deposit}}",
    "RefundRequested": "Refund requested",
    "RefundReturned": "Refund declined, back in balance",
    "Release": "Returned from: {{cycle}}",
    "Reserve": "Set aside: {{cycle}}",
    "Spend": "Statement paid: {{statement}} · {{cycle}}",
    "Promotion": "Featured listing {{promotion}}: {{cycle}}"
  },
  "wallet": {
    "amount": "Amount",
    "amountRange": "Enter an amount between {{min}} and {{max}}.",
    "announceTransfer": "Announce transfer",
    "available": "Available",
    "availableHint": "Can be set aside for new jobs or used for statements.",
    "balanceAfter": "Balance after",
    "cancelDeposit": "Cancel",
    "cancelDepositBody": "If you have not sent the transfer yet, you can cancel this announcement.",
    "cancelDepositTitle": "Cancel {{code}}?",
    "card": "Card",
    "cardBody": "You are taken to the payment page; once paid, the amount is added to your balance right away.",
    "cardDepositDone": "Card top-up complete; the amount was added to your balance.",
    "cardDepositFailed": "The card top-up did not complete.",
    "csv": {
      "available": "Available change",
      "availableAfter": "Available balance",
      "by": "By",
      "date": "Date",
      "description": "Description",
      "reserved": "Set-aside change",
      "reservedAfter": "Set-aside balance"
    },
    "exportCsv": "Download CSV",
    "held": "Set aside",
    "holderName": "Account holder",
    "ledger": "Movements",
    "method": "Payment method",
    "noEntries": "No movements yet.",
    "owed": "Owed",
    "payByCard": "Pay by card",
    "pending": "Pending top-ups",
    "refund": "Request refund",
    "refundHint": "Your available balance is {{available}}. The amount leaves the balance when you ask; TestRome sends it by bank transfer.",
    "refundRequested": "Your refund request was received.",
    "refundTitle": "Request a refund",
    "refundTooMuch": "You can ask for at most {{available}}.",
    "refunds": "Refund requests",
    "releasable": "{{amount}} can be released",
    "releaseState": "Release",
    "requestRefund": "Request refund",
    "reservations": "Job budgets",
    "reserved": "Set aside for jobs",
    "reservedHint": "Secured for live jobs.",
    "showAll": "All movements ({{count}})",
    "showLess": "Show less",
    "subtitle": "Money you paid in advance. Job budgets are set aside from it and statements are paid from it.",
    "system": "System",
    "title": "Balance",
    "topUp": "Top up",
    "topUpHint": "The balance funds job budgets and statements; you can ask for unused money back.",
    "topUpTitle": "Top up your balance",
    "total": "Total",
    "transfer": "Bank transfer",
    "transferAnnounced": "{{code}} created. Put this code in the transfer description.",
    "transferBody": "You get a top-up code. Put it in the transfer description; once the money arrives TestRome confirms it and the amount is added to your balance."
  },
  "adminWallet": {
    "confirmDeposit": "Arrived, confirm",
    "confirmTitle": "Did {{code}} · {{amount}} arrive?",
    "confirmed": "Top-up confirmed; the amount was added to the customer's balance.",
    "deposits": "Top-ups awaiting confirmation",
    "depositsHint": "Match the top-up code (YK-…) in the transfer description, then confirm.",
    "markSent": "Sent",
    "noDeposits": "No top-ups awaiting confirmation.",
    "noRefunds": "No pending refund requests.",
    "note": "Note (shown to the customer)",
    "organization": "Organization",
    "recent": "Recent balance activity",
    "refund": "Refund",
    "refunds": "Refund requests",
    "refundsHint": "Send the amount to the customer's IBAN, then mark it sent.",
    "reject": "Decline",
    "rejectDepositTitle": "Decline {{code}}?",
    "rejectRefundTitle": "Decline the refund request of {{org}}?",
    "rejected": "Declined.",
    "sent": "Refund marked as sent.",
    "sentTitle": "Sent {{amount}} to {{org}}?",
    "totalAvailable": "Customer balances (available)",
    "totalReserved": "Set aside for jobs (secured)"
  },
  "documents": {
    "amount": "Amount",
    "annual": "Yearly earnings summary",
    "annualDisclaimer": "This summary is prepared from TestRome records for information only. It does not replace an invoice or freelance receipt; ask your accountant about your tax return and obligations.",
    "annualTitle": "Yearly earnings summary · {{year}}",
    "byCustomer": "By customer",
    "byMonth": "By month",
    "csv": {
      "customer": "Customer",
      "date": "Date",
      "earning": "Earning",
      "job": "Job",
      "payout": "Payout",
      "status": "Status",
      "type": "Type"
    },
    "customer": "Customer",
    "description": "Description",
    "details": "Detailed breakdown",
    "disclaimer": "This document is for information only and does not replace an invoice, e-archive invoice or freelance receipt. Official documents are issued separately as the law requires; ask your accountant about tax matters.",
    "earned": "Earned",
    "entries": "Entries",
    "entriesTitle": "All earnings entries",
    "fee": "Fee document",
    "feeColumn": "Service fee ({{percent}}%)",
    "feeLine": "TestRome platform service fee · statement {{code}} ({{percent}}%)",
    "feeLines": "Service fee",
    "feePassThrough": "The {{amount}} passed on to {{count}} testers on this statement is not part of the service fee; TestRome forwards it to them.",
    "feeTitle": "Platform service fee",
    "generated": "Generated: {{date}}",
    "howToPay": "How to pay",
    "issued": "Issued: {{date}}",
    "job": "Job",
    "lines": "Owed to testers",
    "method": "Method",
    "month": "Month",
    "notYetPaid": "Not sent yet",
    "paidLine": "Paid: {{date}} · {{method}}",
    "paidOut": "Sent to you",
    "payouts": "Payouts",
    "print": "Print / PDF",
    "reference": "Reference",
    "statement": "Statement document",
    "statementTitle": "Statement",
    "taxLine": "Tax office: {{office}} · Tax no: {{number}}",
    "total": "Total",
    "transferLine": "Send {{amount}} to {{name}} ({{bank}}, IBAN {{iban}}) with {{reference}} in the description.",
    "year": "Year"
  },
  "recordingMode": {
    "ScreenVideo": "Mobile app (screen video)",
    "ScreenVideoHint": "No SDK needed. The tester uploads the phone's screen recording and marks where each step starts.",
    "Sdk": "Web app (recorded by the SDK)",
    "SdkHint": "The TestRome SDK in your app records every session, click and page change by itself.",
    "badge": "Screen recording",
    "SdkApp": "Android app (recorded automatically by the SDK)",
    "SdkAppHint": "The TestRome Android SDK in your app records screens, taps, network requests, errors and crashes. The tester connects the app to the test with a QR code or a pairing code.",
    "SdkIos": "iOS app (recorded automatically by the SDK)",
    "SdkIosHint": "The TestRome iOS SDK in your app records screens, taps, filled-in fields, network requests, errors and crashes. The tester connects the app to the test with a link or a pairing code."
  },
  "level": {
    "Bronze": "Bronze",
    "Gold": "Gold",
    "New": "New",
    "Platinum": "Platinum",
    "Silver": "Silver",
    "academy": "Academy",
    "academyHint": "A free practice job; an accepted run means the academy is passed.",
    "academyHow": "Run the scenario of the academy job and upload the screen recording; the TestRome team reviews it.",
    "academyNotPassed": "Has not passed the academy",
    "academyPassed": "Passed the academy",
    "adminHint": "Mark these when the tester passed the academy another way or you checked their identity documents.",
    "adminTitle": "Admin: level conditions",
    "anyLevel": "All levels",
    "atLeast": "At least {{level}}",
    "check": {
      "acceptanceRate": "Acceptance rate at least {{need}}%",
      "acceptedRuns": "At least {{need}} accepted runs",
      "averageConfidence": "Average confidence at least {{need}}",
      "confirmedBugs": "At least {{need}} confirmed bugs",
      "identityVerified": "Identity verification",
      "qualified": "Pass the academy",
      "rating": "Customer rating at least {{need}} (with enough reviews)"
    },
    "grantAcademy": "Count the academy as passed",
    "hint": "The level follows accepted work, confirmed bugs, acceptance rate, confidence score, the academy and the identity check.",
    "identityHow": "Done when you open a card payout account under Earnings, or when TestRome verifies your identity.",
    "met": "done",
    "minLevel": "Minimum level",
    "missing": "missing",
    "nextIs": "What {{level}} needs",
    "notVerified": "Identity not verified",
    "openAcademy": "Open the academy job",
    "qualifiedOn": "Academy: {{date}}",
    "revokeAcademy": "Take the academy back",
    "revokeIdentity": "Remove verification",
    "subtitle": "Your level follows your reviewed work, the academy and the identity check. Customers may ask for a minimum level.",
    "title": "Your level",
    "top": "You are at the top level. Congratulations!",
    "verified": "Identity verified",
    "verifiedByProvider": "Identity verified by the payment provider",
    "verifiedHint": "Identity checked by TestRome or the payment provider.",
    "verifyIdentity": "Verify identity"
  },
  "integrations": {
    "allSeverities": "All",
    "autoOff": "sent by hand",
    "autoOn": "confirmed bugs open automatically",
    "connect": "Connect",
    "edit": "Edit",
    "event": {
      "BugConfirmed": "Bug confirmed",
      "BugReported": "New bug reported",
      "CycleClosed": "Test cycle closed (with report)",
      "CyclePublished": "Test cycle started"
    },
    "field": {
      "account": "Account e-mail",
      "accountHint": "Needed for Jira Cloud; leave empty for Data Center.",
      "autoCreate": "Open confirmed bugs in {{name}} automatically",
      "enabled": "Integration on",
      "events": "Events to post",
      "githubApi": "API address",
      "githubApiHint": "Change it if you use GitHub Enterprise.",
      "issueType": "Issue type",
      "issueTypeHint": "The type the project uses for bugs (usually Bug).",
      "jiraSite": "Jira address",
      "minSeverity": "Bugs opened automatically",
      "minSeverityChat": "Bug notifications",
      "projectKey": "Project key",
      "repository": "Repository (owner/repo)",
      "token": "Token",
      "webhook": "Webhook address"
    },
    "help": {
      "GitHub": "In GitHub, go to Settings → Developer settings → Fine-grained tokens and create a token for this repository only with \"Issues: Read and write\".",
      "Jira": "For Jira Cloud, enter your account e-mail and an API token from id.atlassian.com → Security → API tokens. For Jira Data Center, leave the e-mail empty and use a personal access token (PAT).",
      "Slack": "Add the \"Incoming Webhooks\" app to your Slack channel and paste the webhook address it gives you."
    },
    "kind": {
      "GitHub": "GitHub",
      "Jira": "Jira",
      "Slack": "Slack"
    },
    "lastError": "Last error ({{at}}): {{error}}",
    "lastSuccess": "Last delivered: {{at}}",
    "noEvents": "no events selected",
    "notSendable": "Rejected or duplicate bugs cannot be sent.",
    "openIn": "Open in {{name}}",
    "pitch": {
      "GitHub": "Open bugs as issues in a GitHub repository.",
      "Jira": "Open confirmed bugs as Jira issues.",
      "Slack": "Post new and confirmed bugs, and test cycles starting and ending, to a channel."
    },
    "pushed": "Opened in {{name}}: {{key}}",
    "remove": "Remove",
    "removeBody": "The settings and the token are deleted. Links to issues already opened stay on the bugs.",
    "removeTitle": "Remove {{name}}?",
    "removed": "{{name}} removed",
    "saved": "{{name}} saved",
    "secretKept": "Stored: {{hint}}. Type a new one to change it.",
    "secretPlaceholder": "Leave empty to keep it",
    "sendAgain": "Send again",
    "sendTest": "Send a test message",
    "sendTo": {
      "Jira": "Send to Jira",
      "GitHub": "Send to GitHub",
      "Slack": "Send to Slack"
    },
    "sending": {
      "Jira": "Sending to Jira…",
      "GitHub": "Sending to GitHub…",
      "Slack": "Sending to Slack…"
    },
    "severityAndUp": "{{severity}} and worse",
    "status": {
      "failing": "Failing",
      "notSet": "Not connected",
      "off": "Off",
      "on": "On"
    },
    "subtitle": "Send bugs to Jira or GitHub; let your Slack channel hear about new bugs and test cycles.",
    "test": "Test connection",
    "title": "Integrations",
    "trackers": "Issue tracker",
    "uncertain": {
      "Jira": "Outcome in Jira unknown",
      "GitHub": "Outcome in GitHub unknown",
      "Slack": "Outcome unknown"
    },
    "uncertainHelp": "The outcome of sending is unknown ({{error}}). Search {{name}} for \"[TestRome #{{number}}]\"; if there is no issue, send it again."
  },
  "report": {
    "bands": "Confidence",
    "bugs": "Bugs",
    "bugsCsv": "Bug list (CSV)",
    "bySeverity": "Bugs by severity",
    "cases": "Test cases",
    "col": {
      "accepted": "Accepted",
      "bugs": "Bugs",
      "case": "Case",
      "confidence": "Confidence",
      "confirmed": "Confirmed",
      "date": "Date",
      "reporter": "Reporter",
      "runs": "Runs",
      "severity": "Severity",
      "status": "Status",
      "tester": "Tester",
      "title": "Title",
      "total": "Total",
      "tracker": "Tracker"
    },
    "cost": "Cost",
    "costEarnings": "Testers' accepted work",
    "costEscrow": "Reserved budget (left / reserved)",
    "costFee": "Platform fee",
    "costPaid": "Paid",
    "costTotal": "Total",
    "documentTitle": "{{name}} · Test report",
    "environments": "Environments",
    "exploratory": "Exploratory sessions",
    "footer": "Generated by TestRome on {{date}} for {{name}}. Figures show the state at that moment.",
    "generated": "Generated {{date}}",
    "noReasons": "Nothing lowered the scores.",
    "noRuns": "No submitted runs yet.",
    "ongoing": "ongoing",
    "outcomes": "Case outcomes",
    "period": "Period",
    "platform": "Platform",
    "reasons": "What lowered confidence",
    "results": "Results",
    "runsCount_one": "{{count}} run",
    "runsCount_other": "{{count}} runs",
    "sourcing": "Testers",
    "target": "Tested address",
    "testers": "Testers",
    "tile": {
      "accepted": "Acceptance",
      "bugs": "Bugs found",
      "confidence": "Average confidence",
      "outOf": "out of 100",
      "reviewed_one": "{{count}} run reviewed",
      "reviewed_other": "{{count}} runs reviewed",
      "runs": "Runs",
      "serious_one": "{{count}} critical or major",
      "serious_other": "{{count}} critical or major",
      "testers_one": "{{count}} tester",
      "testers_other": "{{count}} testers"
    },
    "title": "Test report",
    "unknownEnvironment": "Not given",
    "version": "version {{version}}"
  },
  "admin": {
    "acceptance": "Acceptance: {{value}}",
    "acceptedRuns": "Accepted runs",
    "account": "Account",
    "activeCycles": "Running test cycles",
    "activeTesters_one": "{{count}} active in 30 days",
    "activeTesters_other": "{{count}} active in 30 days",
    "allTime": "All time: {{value}}",
    "awaitingPayout": "To pay out",
    "awaitingTransfer": "Statements awaiting payment: {{value}}",
    "bugs30": "Bugs reported",
    "bugsConfirmed_one": "{{count}} confirmed",
    "bugsConfirmed_other": "{{count}} confirmed",
    "clear": "No problem",
    "clearBody": "For example two family members on one computer. The accounts no longer block each other on jobs; the group is listed again if it grows.",
    "clearTitle": "May these accounts stay linked?",
    "cleared": "Group marked as reviewed",
    "clusterTitle_one": "{{count}} account",
    "clusterTitle_other": "{{count}} accounts",
    "col": {
      "earned": "Earned",
      "joined": "Joined",
      "lastSeen": "Last sign-in",
      "roles": "Roles",
      "runs": "Runs",
      "user": "User"
    },
    "confirmedBugs": "Confirmed bugs",
    "customers": "Customers",
    "dashboardTitle": "Overview",
    "days_one": "{{count}} day",
    "days_other": "{{count}} days",
    "decidedBy": "{{name}} · {{at}}",
    "decision": {
      "Cleared": "No problem",
      "Suspended": "Suspended"
    },
    "decisions": "Decisions",
    "disputes": "Open disputes",
    "disputesHint": "{{resolved}} resolved in 30 days · {{time}} on average",
    "earnedShort": "earned {{amount}}",
    "fees30": "Platform revenue",
    "filter": "Kind of user",
    "filters": {
      "all": "All",
      "customers": "Customers",
      "linked": "Linked",
      "suspended": "Suspended",
      "testers": "Testers"
    },
    "fraudSubtitle": "Accounts opened in the same browser, or paid to the same IBAN or phone, are most likely one person. They cannot work the same job; review them and decide here.",
    "fraudTitle": "Linked accounts",
    "generated": "As of {{at}}",
    "hours_one": "{{count}} hour",
    "hours_other": "{{count}} hours",
    "includeReviewed": "Show decided groups too",
    "joinedLine": "Joined {{at}}",
    "lessThanHour": "under an hour",
    "linkedCount_one": "{{count}} linked account",
    "linkedCount_other": "{{count}} linked accounts",
    "linkedSince": "linked since {{at}}",
    "logs": "Logs",
    "memberships": "Memberships",
    "money": "Money (last 30 days)",
    "new30_one": "{{count}} new in 30 days",
    "new30_other": "{{count}} new in 30 days",
    "next": "Next",
    "noClusters": "No linked accounts",
    "noClustersBody": "No accounts share a browser, IBAN or phone number.",
    "noSignals": "Nothing recorded yet.",
    "noUsers": "No matching users",
    "note": "Note",
    "openJobs_one": "{{count}} open listing",
    "openJobs_other": "{{count}} open listings",
    "pageOf": "{{from}}–{{to}} of {{total}}",
    "payoutHeld": "Account suspended: payout held",
    "pendingReviews_one": "{{count}} run awaiting review",
    "pendingReviews_other": "{{count}} runs awaiting review",
    "people": "People",
    "platformAdmin": "Platform admin",
    "prev": "Previous",
    "profile": "Profile",
    "reason": "Reason",
    "reinstate": "Reinstate",
    "reinstated": "Account reinstated",
    "reviewTime": "Average review time",
    "risk": {
      "High": "High risk",
      "Medium": "Medium risk"
    },
    "runs30": "Runs submitted",
    "search": "Search",
    "searchPlaceholder": "Name, e-mail or watermark code (TR-…)",
    "selfDealing": "Tested a job of a company one of them belongs to: {{job}} ({{org}}) —",
    "shared": {
      "Device": "Same browser",
      "Iban": "Same IBAN",
      "Ip": "Same IP address",
      "Phone": "Same phone"
    },
    "sharedJob": "Worked the same job: {{job}} ({{org}}) —",
    "sharedWith": "Shared with:",
    "signal": {
      "Device": "Browser",
      "Iban": "IBAN",
      "Ip": "IP address",
      "Phone": "Phone"
    },
    "signalSeen_one": "First {{first}} · last {{last}} · {{count}} time",
    "signalSeen_other": "First {{first}} · last {{last}} · {{count}} times",
    "signals": "Identifying details",
    "signalsHint": "Browsers, IP addresses and payout details seen for this account. Those shared with other accounts are marked.",
    "suspend": "Suspend",
    "suspendAll": "Suspend all",
    "suspendAllBody": "Every account in the group (except platform admins) is suspended and told the reason by e-mail.",
    "suspendAllTitle_one": "Suspend {{count}} account?",
    "suspendAllTitle_other": "Suspend {{count}} accounts?",
    "suspendBody": "The account is signed out at once and cannot sign in. Its open assignments go back to others, pending applications are withdrawn and payouts are held. The person is told the reason by e-mail.",
    "suspendTitle": "Suspend {{name}}?",
    "suspended": "Account suspended",
    "suspendedAll": "Accounts suspended",
    "suspendedBadge": "Suspended",
    "suspendedCount_one": "{{count}} account suspended",
    "suspendedCount_other": "{{count}} accounts suspended",
    "suspendedLine": "Suspended on {{at}} by {{by}}: {{reason}}",
    "tester": "Tester",
    "testers": "Testers",
    "todo": "Waiting for you",
    "todoDeposits": "Bank-transfer top-up(s) to confirm",
    "todoDisputes": "Dispute(s) escalated to the platform",
    "todoFraud": "Group(s) of linked accounts to decide on",
    "todoPayouts": "To pay out to testers: {{amount}}",
    "todoRefunds": "Balance refund(s) to send",
    "todoTransfers": "Statements awaiting payment: {{amount}}",
    "users": "Users",
    "usersCount_one": "{{count}} user",
    "usersCount_other": "{{count}} users",
    "usersTitle": "Users",
    "volume30": "Paid",
    "walletReserved": "Reserved for jobs: {{value}}",
    "wallets": "Customer balances",
    "weekRuns": "Runs submitted",
    "weekUsers": "New users",
    "weekVolume": "Paid",
    "weeks": "Last 12 weeks",
    "work": "Work (last 30 days)",
    "watermarkCodeHint": "The code printed on the screens of confidential jobs"
  },
  "privacy": {
    "acceptNotice": "I have read the privacy notice on how my personal data is processed.",
    "acknowledge": "I have read it",
    "always": "Recorded in every test",
    "consents": "Consents",
    "deviceAllow": "I agree",
    "deviceAskBody": "The customer can see on which hardware their app was tested, and bugs are easier to reproduce in the same environment. The OS version, screen resolution, CPU core count, approximate memory, graphics card and connection type are collected. It is optional, does not affect your jobs, and you can withdraw it any time on the Privacy page.",
    "deviceAskTitle": "Share detailed device information?",
    "deviceDeclined": "OK; detailed device information will not be collected.",
    "deviceDeny": "No, thanks",
    "deviceGranted": "Thank you; your device details will be shared in tests.",
    "deviceOptional": "Optional: I consent to detailed device information (OS version, screen, CPU, memory, graphics card, connection) being collected while I test.",
    "deviceWithdrawn": "Consent withdrawn; details collected earlier were deleted.",
    "gateIntro": "Before you continue, please read how your personal data is processed.",
    "hideText": "Hide text",
    "history": "Consent history",
    "historyNo": "declined / withdrawn",
    "historyYes": "accepted",
    "kind": {
      "DeviceDetails": "Detailed device information (explicit consent)",
      "PrivacyNotice": "Privacy notice"
    },
    "kindHint": {
      "DeviceDetails": "Collecting the OS version, screen, CPU, memory, graphics card and connection while you test. Optional.",
      "PrivacyNotice": "Explains which data is processed, why and for how long, and your rights. It must be read to use the platform."
    },
    "latestRun": "{{run}} · {{at}}",
    "loading": "Loading…",
    "menu": "Privacy",
    "nothingYet": "You have not run a test yet.",
    "noticeRequired": "Please read and acknowledge the privacy notice to continue.",
    "readConsent": "Consent text",
    "readFull": "Full text",
    "readNotice": "Read it",
    "recordedHint_one": "From your latest test. Detailed information exists for {{count}} test.",
    "recordedHint_other": "From your latest test. Detailed information exists for {{count}} tests.",
    "recordedTitle": "Device information recorded about you",
    "showText": "Show text",
    "signOut": "Sign out",
    "state": {
      "acknowledged": "Read",
      "declined": "Declined",
      "granted": "Granted",
      "pending": "Not read",
      "unanswered": "Not answered"
    },
    "subtitle": "Your personal data, the consents you gave and the device details recorded about you",
    "title": "Privacy",
    "version": "text {{version}}",
    "withdraw": "Withdraw consent",
    "withdrawBody": "From now on detailed device information is not collected and what was collected is deleted. The basic records (browser, OS, screen recording) continue as part of the service.",
    "withdrawTitle": "Withdraw your consent?"
  },
  "device": {
    "available": "Available area",
    "browser": "Browser",
    "collectedAt": "Collected {{at}}",
    "cores_one": "{{count}} core",
    "cores_other": "{{count}} cores",
    "cpu": "CPU",
    "environment": "Environment",
    "formFactor": "Form factor",
    "formFactors": {
      "Desktop": "Desktop",
      "Mobile": "Mobile",
      "Tablet": "Tablet",
      "XR": "XR (virtual/augmented reality)",
      "EInk": "E-ink",
      "Watch": "Watch",
      "Automotive": "Automotive"
    },
    "fromBrowser": "Reported by the browser",
    "fromVideo": "Reported by the screen recording file",
    "gpu": "Graphics card",
    "language": "Language",
    "languages": "Languages",
    "memory": "Memory (RAM)",
    "memoryAtLeast": "{{gb}} GB or more",
    "model": "Device model",
    "network": "Connection",
    "noTouch": "none",
    "none": "No detailed device information for this test.",
    "os": "Operating system",
    "recordedAt": "Recorded at",
    "reducedMotion": "reduced motion on",
    "saveData": "data saver on",
    "scheme": {
      "dark": "dark theme",
      "light": "light theme"
    },
    "screen": "Screen",
    "storage": "Browser storage quota",
    "theme": "Appearance",
    "timezone": "Time zone",
    "touch": "Touch",
    "touchPoints_one": "{{count}} touch point",
    "touchPoints_other": "{{count}} touch points",
    "userAgent": "Browser id (user agent)",
    "videoDevice": "Device",
    "videoSize": "Video resolution",
    "window": "Window"
  },
  "offers": {
    "accept": "Join",
    "accepted": "You joined {{team}}.",
    "decline": "Decline",
    "declined": "You declined the offer from {{team}}.",
    "dialogHint": "Write a few words: what the team works on and what you expect. If they accept, they join as a tester; set their earnings share afterwards under Earnings shares.",
    "dialogTitle": "Invite {{name}} to the team",
    "from": "from {{name}} · {{at}}",
    "inboxHint": "A team lead invited you to their team. If you join, the lead can hand you tasks from the team's jobs; earnings are split by the team's shares.",
    "inboxTitle_one": "A team offer for you",
    "inboxTitle_other": "Team offers for you ({{count}})",
    "invite": "Invite to team",
    "message": "Your message",
    "messageHint": "Up to 1000 characters; the tester sees it with the offer.",
    "messagePlaceholder": "E.g. We need help on the Android side of mobile payment jobs.",
    "send": "Send offer",
    "sent": "Offer sent: {{name}}",
    "status": {
      "Accepted": "Accepted",
      "Declined": "Declined",
      "Pending": "Awaiting answer",
      "Withdrawn": "Withdrawn"
    },
    "team": "Team",
    "withdraw": "Withdraw",
    "withdrawBody": "The tester will no longer see or be able to accept it.",
    "withdrawTitle": "Withdraw the offer to {{name}}?",
    "withdrawn": "Offer withdrawn."
  },
  "teamPanel": {
    "acceptance": "Acceptance {{rate}}",
    "acceptanceShort": "Accepted",
    "activeJobs": "Active jobs",
    "allHint": "Every task in the team's active jobs. Tasks nobody has started can go to another member.",
    "allJobs": "All jobs",
    "allTitle": "All tasks",
    "alreadyMember": "In the team",
    "anyone": "Anyone",
    "applyPlan_one": "Hand out {{count}} task",
    "applyPlan_other": "Hand out {{count}} tasks",
    "badge": "Team panel",
    "chooseMember": "Choose a member",
    "deadlines": "Deadlines",
    "deviceFit": "This member has a device for this environment",
    "distributeHint": "Tasks go to the members you choose: the earliest deadlines are placed first; a member with a device for the task and the fewest open tasks comes first. Nobody gets the same case of a job twice. You see the plan before anything changes.",
    "distributeTitle_one": "Spread {{count}} task",
    "distributeTitle_other": "Spread {{count}} tasks",
    "distributed_one": "{{count}} task handed out.",
    "distributed_other": "{{count}} tasks handed out.",
    "dueSoon_one": "{{count}} due within 48 hours",
    "dueSoon_other": "{{count}} due within 48 hours",
    "earned30": "Earned (30 days)",
    "earned30Short": "Earned (30 d)",
    "earningsSub": "Pending {{pending}} · paid {{paid}}",
    "equalShort": "equal",
    "findHint": "Search testers with a profile and offer them a place in the team.",
    "findTitle": "Find testers",
    "findWork": "Find work",
    "fitCount_one": "{{count}} member has a device",
    "fitCount_other": "{{count}} members have a device",
    "fits": "has a device",
    "give": "Give",
    "giveTo": "To",
    "given_one": "{{count}} task given to {{name}}",
    "given_other": "{{count}} tasks given to {{name}}",
    "holder": "Held by",
    "inProgress": "In progress",
    "inProgressShort": "Running",
    "job": "Job",
    "last30": "Submitted in 30 days",
    "last30Detail": "{{accepted}} accepted, {{rejected}} rejected",
    "last30Short": "Submitted (30 d)",
    "lastActive": "Last worked",
    "moved": "Bulk hand-outs, the team overview and offers are in the team panel.",
    "noDeviceFit": "None of the chosen members has a device for this environment",
    "noOffers": "You haven't sent any offers yet.",
    "noTeamBody": "The team panel is for the leads of a public team.",
    "noTeamTitle": "You don't lead a team",
    "note": "Note",
    "noteClear": "Remove note",
    "noteCleared": "Note removed.",
    "noteFor": "Note for {{key}}",
    "noteHint": "Whoever runs the task sees this note in their task list and when starting the test.",
    "noteOptional": "Note (optional)",
    "notePlaceholder": "E.g. use the iPhone, try the coupon twice",
    "noteSaved": "Note saved.",
    "noteTitle": "{{key}} · lead's note",
    "nothingWaiting": "Nothing is waiting to be handed out",
    "nothingWaitingBody": "Tasks of new jobs the team takes first go to the lead and are listed here.",
    "offersHint": "Offers awaiting an answer and those answered in the last 30 days.",
    "offersOpen_one": "{{count}} offer awaiting an answer",
    "offersOpen_other": "{{count}} offers awaiting an answer",
    "offersTitle": "Offers sent",
    "open": "Open tasks",
    "openNow_one": "{{count}} open task now",
    "openNow_other": "{{count}} open tasks now",
    "openPanel": "Team panel",
    "openPeople": "Review",
    "openTasks": "Open tasks",
    "overdue_one": "{{count}} task overdue",
    "overdue_other": "{{count}} tasks overdue",
    "pendingApplications_one": "{{count}} application awaiting an answer",
    "pendingApplications_other": "{{count}} applications awaiting an answer",
    "pendingOf": "Pending {{amount}}",
    "plan": "Plan",
    "previewPlan": "Show the plan",
    "requestsWaiting_one": "{{count}} join request waiting",
    "requestsWaiting_other": "{{count}} join requests waiting",
    "select": "Select {{key}}",
    "selectAll": "Select all",
    "selected_one": "{{count}} task selected",
    "selected_other": "{{count}} tasks selected",
    "share": "Share",
    "spread": "Spread evenly…",
    "switchTeam": "Team",
    "tabOverview": "Overview",
    "tabPeople": "Members and offers",
    "tabShares": "Earnings shares",
    "tabWork": "Hand out work",
    "tabs": "Team panel sections",
    "teamPage": "Team page",
    "view": "View",
    "viewAll": "All tasks",
    "viewWaiting": "Waiting to be handed out",
    "waitingHint": "Tasks held by a lead that nobody has started. Select them and give them to a member, or spread them over members.",
    "waitingTitle": "Tasks waiting to be handed out",
    "whoGetsWork": "Who gets work?",
    "withLeads_one": "{{count}} task waiting with the lead",
    "withLeads_other": "{{count}} tasks waiting with the lead",
    "workload": "Members' workload",
    "workloadHint": "Open tasks in active jobs, tests submitted in the last 30 days (accepted/rejected) and earnings through the team.",
    "tabRhythm": "Work rhythm"
  },
  "cv": {
    "title": "My CV",
    "subtitle": "Customers look at your CV when choosing testers. Nothing is required.",
    "welcomeTitle": "Fill in your CV",
    "welcomeSubtitle": "Welcome {{name}}! Before you start, tell customers a little about yourself: they read your CV when choosing testers. Nothing is required; only what you fill in is shown.",
    "visibility": "Customers (the companies that post work), your team leads and platform admins can read your CV; other testers cannot. Leave out phone numbers, e-mail and addresses: you talk through TestRome messages.",
    "viewAsCustomer": "What customers see",
    "summary": "Summary",
    "summaryHint": "What kind of products have you tested, what are you good at?",
    "summaryLabel": "Short summary",
    "summaryPlaceholder": "E.g. I have been testing e-commerce and payment flows for 3 years…",
    "testingYears": "Testing experience (years)",
    "testingTypes": "Kinds of testing",
    "testingTypesHint": "Pick the kinds of testing you do.",
    "type": {
      "Manual": "Manual testing",
      "Exploratory": "Exploratory",
      "Regression": "Regression",
      "Automation": "Automation",
      "Api": "API testing",
      "Performance": "Performance",
      "Security": "Security",
      "Accessibility": "Accessibility",
      "Usability": "Usability",
      "Localization": "Localization",
      "Mobile": "Mobile",
      "Game": "Game testing"
    },
    "experience": "Work experience",
    "addExperience": "Add experience",
    "noExperience": "No experience added yet.",
    "experienceRow": "Experience {{n}}",
    "jobTitle": "Position",
    "company": "Company",
    "startYear": "Start year",
    "endYear": "End year",
    "current": "I currently work here",
    "description": "Description",
    "education": "Education",
    "addEducation": "Add education",
    "noEducation": "No education added yet.",
    "educationRow": "Education {{n}}",
    "school": "School",
    "degree": "Degree",
    "field": "Field of study",
    "graduationYear": "Graduation year",
    "certificates": "Certificates",
    "addCertificate": "Add certificate",
    "noCertificates": "No certificates added yet.",
    "certificateRow": "Certificate {{n}}",
    "certificateName": "Certificate",
    "issuer": "Issued by",
    "year": "Year",
    "languages": "Languages",
    "addLanguage": "Add language",
    "noLanguages": "No languages added yet.",
    "language": "Language",
    "languageLevel": "Level",
    "level": {
      "Basic": "Basic",
      "Intermediate": "Intermediate",
      "Advanced": "Advanced",
      "Native": "Native"
    },
    "tools": "Tools",
    "toolsHint": "Testing and bug-tracking tools you use.",
    "addTool": "Add tool",
    "noTools": "No tools added yet.",
    "links": "Links",
    "linksHint": "LinkedIn, GitHub or a portfolio (up to 5).",
    "addLink": "Add link",
    "noLinks": "No links added yet.",
    "linkLabel": "Title",
    "linkUrl": "Address",
    "removeRow": "Remove: {{row}}",
    "optionalNote": "You can leave it empty and continue; complete it later from “My CV” in the menu.",
    "optionalShort": "Nothing is required.",
    "saveAndContinue": "Save and continue",
    "welcomeSaved": "Your CV is saved.",
    "section": "CV",
    "open": "CV",
    "titleOf": "{{name}} · CV",
    "emptyTitle": "No CV yet",
    "emptyBody": "{{name}} has not written anything in their CV yet.",
    "present": "Present",
    "untitled": "(untitled)",
    "yearsOfTesting_one": "{{count}} year of testing",
    "yearsOfTesting_other": "{{count}} years of testing",
    "updatedAt": "Last updated: {{at}}",
    "languageRow": "Language {{n}}",
    "linkRow": "Link {{n}}",
    "import": {
      "title": "Is your CV ready as a PDF?",
      "hint": "Upload it and we fill in the fields for you. You can check and fix everything before saving.",
      "pick": "Fill from PDF",
      "file": "CV PDF file",
      "privacyRules": "The file is not uploaded: your browser reads the PDF's text and TestRome places it in the fields. Nothing is kept until you save.",
      "privacyAi": "The PDF is sent to an AI model (Anthropic Claude) to place it in the fields and is not kept. Nothing is kept until you save.",
      "reading": "Reading the PDF…",
      "placing": "Filling in the fields…",
      "placingAi": "The AI is reading your CV; this may take a moment…",
      "notPdf": "{{name}} is not a PDF.",
      "tooLarge": "{{name}} is too large; up to {{mb}} MB.",
      "unreadable": "The PDF could not be opened. It may be password protected or damaged.",
      "noText": "The PDF has no readable text. It may be a scan (a picture): try a PDF saved from Word or a CV site, or fill in the fields yourself.",
      "resultTitle": "Added from the PDF",
      "byAi": "read by AI",
      "check": "Check it, fix anything wrong or missing, and press Save. What the form already had was not changed.",
      "nothingNew": "The PDF had nothing the form does not have yet.",
      "undo": "Undo",
      "undone": "What the PDF added was undone.",
      "added": {
        "summary": "summary",
        "testingYears": "years of testing",
        "experience_one": "{{count}} job",
        "experience_other": "{{count}} jobs",
        "education_one": "{{count}} school",
        "education_other": "{{count}} schools",
        "certificates_one": "{{count}} certificate",
        "certificates_other": "{{count}} certificates",
        "languages_one": "{{count}} language",
        "languages_other": "{{count}} languages",
        "tools_one": "{{count}} tool",
        "tools_other": "{{count}} tools",
        "testingTypes_one": "{{count}} testing type",
        "testingTypes_other": "{{count}} testing types",
        "links_one": "{{count}} link",
        "links_other": "{{count}} links"
      }
    }
  },
  "phone": {
    "title": "Join the test from your phone",
    "tester": "Tester",
    "job": "Job",
    "validUntil": "This link works until {{at}} and until the test is submitted.",
    "invalidTitle": "Invalid link",
    "closedTitle": "Link closed",
    "videoTitle": "Screen recording",
    "videoStep1": "Start the phone's screen recording (iPhone: Control Centre → Screen Recording, Android: quick settings → Screen record).",
    "videoStep2": "Do the test in the app, then stop the recording.",
    "videoStep3": "Pick the video with the button below; it appears on the test screen on your computer by itself.",
    "videoPick": "Pick the screen recording",
    "videoReplace": "Upload another video",
    "videoDone": "Screen recording uploaded",
    "videoDoneHint": "{{at}} · Continue on the test screen on your computer.",
    "appTitle": "App",
    "appHint": "If the app is installed on this phone, the button below opens it connected to this test; recording starts right away.",
    "openApp": "Open the app",
    "openedHint": "If the app did not open, check that it is installed, or use a pairing code.",
    "showCode": "Show a pairing code",
    "newCode": "New pairing code",
    "tapToOpen": "Tap here if the app did not open"
  },
  "promotion": {
    "featured": "Featured",
    "featuredUntil": "Featured until {{at}}",
    "featuredShort": "Featured · {{at}}",
    "promote": "Feature",
    "titleJob": "Feature this listing",
    "titleTeam": "Feature this team",
    "hintJob": "Featured listings are shown first on the job board with a “Featured” badge, so testers see them first.",
    "hintTeam": "Featured teams are shown first in the team directory with a “Featured” badge, so customers see them first.",
    "runningUntil": "Featured now, until {{at}}.",
    "choose": "How long to feature",
    "free_one": "Free · {{count}} day",
    "free_other": "Free · {{count}} days",
    "freeLeft": "{{left}} of {{total}} free featurings left this month",
    "levelBonus": "+{{count}} for the lead's level",
    "days_one": "{{count}} day",
    "days_other": "{{count}} days",
    "perDay": "{{amount}} a day",
    "method": "Payment method",
    "fromBalance": "From balance ({{amount}})",
    "teamPaysByCard": "Teams pay for featuring by card.",
    "balanceShort": "The balance does not cover this package.",
    "topUp": "Top up",
    "cardOff": "Card payments are not available right now.",
    "billingMissing": "Paying by card needs the billing details (with the T.C. ID number).",
    "fillBilling": "Fill in billing details",
    "buyerHint": "The invoice is issued with these details. Your ID number is stored encrypted.",
    "buyer": {
      "name": "First name",
      "surname": "Last name",
      "identityNumber": "T.C. ID number",
      "phone": "Phone",
      "address": "Address",
      "city": "City"
    },
    "pickOne": "Choose an option",
    "useFree": "Feature for free",
    "payBalance": "Pay {{amount}} from balance",
    "payCard": "Pay by card ({{amount}})",
    "startNote": "Featuring starts right away.",
    "queueNote": "A new featuring starts when the current one ends; they run back to back.",
    "done": "{{code}}: featured from {{from}} to {{to}}.",
    "cardDone": "Payment received; featuring has started.",
    "cardFailed": "The card payment did not complete; nothing was featured.",
    "history": "History ({{count}})",
    "payment": {
      "Free": "Free",
      "Balance": "Balance",
      "Card": "Card"
    },
    "phase": {
      "Live": "Live",
      "Queued": "Queued",
      "Ended": "Ended",
      "Pending": "Awaiting payment",
      "Failed": "Not paid",
      "Cancelled": "Stopped",
      "Active": "Active"
    },
    "blocker": {
      "notActive": "Only a live job can be featured.",
      "notPublic": "Only public listings can be featured.",
      "notMarketplace": "Only marketplace jobs can be featured."
    }
  },
  "promotionAdmin": {
    "live": "Featured now",
    "paidThisMonth": "Featuring revenue this month",
    "freeThisMonth": "Free featurings this month",
    "settings": "Featuring packages",
    "settingsHint": "Monthly free allowances and paid packages. Changes apply at once; featurings already bought are not affected.",
    "jobFree": "Free job featurings per customer a month",
    "teamFree": "Free featurings per team a month",
    "teamFreeHint": "Gold lead +1, Platinum +2",
    "freeDays": "Free featuring length (days)",
    "plansJob": "Job listing packages",
    "plansTeam": "Team packages",
    "days": "Days",
    "price": "Price (TRY)",
    "active": "On sale",
    "addPlan": "Add package",
    "saved": "Featuring settings saved.",
    "updatedAt": "Last changed: {{at}}",
    "liveTitle": "Live and queued",
    "liveHint": "Stop a listing or team that breaks the rules here; refunds are handled separately.",
    "noneLive": "Nothing is featured right now.",
    "recent": "Recent featurings",
    "what": "Listing / team",
    "window": "When",
    "payment": "Payment",
    "target": {
      "Job": "Job listing",
      "Team": "Team"
    },
    "stop": "Stop",
    "stopTitle": "Stop {{code}}?",
    "stopBody": "The featuring ends now; queued ones move up. The amount paid is not refunded automatically.",
    "stopped": "Featuring stopped."
  },
  "nda": {
    "badge": "Confidential · NDA",
    "badgeHint": "Confidential job: details open after accepting the agreement; screens are watermarked.",
    "title": "Confidentiality agreement",
    "gateHint": "{{org}} keeps this job confidential. Read and accept the agreement to see the cases, instructions and the app.",
    "agree": "I have read and accept the agreement",
    "accept": "Accept and continue",
    "accepted": "You accepted the agreement; the job's details are open.",
    "acceptedOn": "You accepted the agreement on {{at}}.",
    "cannotAccept": "Testers working on the job accept it; this is a preview.",
    "recordNote": "The time, a fingerprint of the text and the address you connect from are recorded. Screens carry a watermark with your name and code.",
    "acceptFirst": "Accept the confidentiality agreement first.",
    "casesHidden": "The cases show once the agreement is accepted.",
    "acceptancesButton_one": "Agreement · {{count}} accepted",
    "acceptancesButton_other": "Agreement · {{count}} accepted",
    "acceptancesTitle": "Who accepted the agreement",
    "acceptancesHint": "Every tester accepts it before starting. The address they connected from is kept by the platform, not shown to you.",
    "noneYet": "Nobody has accepted it yet.",
    "person": "Person",
    "acceptedAt": "Accepted",
    "fingerprint": "Text fingerprint",
    "showText": "Show the agreement",
    "casesOpen": "Shown because you accepted the agreement; steps and the app's address open once you take work."
  },
  "vault": {
    "title": "Test accounts",
    "testerHint": "Logins for this job's app. Show a password only when you need it.",
    "customerHint": "Logins for the app under test. Passwords are encrypted; only testers on this job see them and every look is recorded.",
    "shared": "Shared",
    "exclusive": "Personal",
    "yours": "Yours",
    "username": "Username",
    "password": "Password",
    "notes": "Note",
    "show": "Show",
    "claimHint_one": "A personal account can be yours ({{count}} free).",
    "claimHint_other": "A personal account can be yours ({{count}} free).",
    "claim": "Take my account",
    "claimed": "{{label}} is yours now; nobody else uses it.",
    "recorded": "Each time you show a password it is recorded for the customer.",
    "add": "Add account",
    "addTitle": "Add a test account",
    "editTitle": "Edit test account",
    "formHint": "The password and note are stored encrypted; only the customer's team and testers on this job can see them.",
    "label": "Name",
    "labelPlaceholder": "e.g. Standard customer",
    "keepPassword": "Leave empty to keep the password.",
    "notesHint": "Optional: e.g. a card number, where to get a 2FA code.",
    "notesReplace": "Anything you write replaces the old note; leaving it empty removes it.",
    "exclusiveLabel": "Personal (a separate account for each tester)",
    "exclusiveHint": "Personal accounts are handed to testers one by one, so two people never change the same basket or profile.",
    "added": "Test account added.",
    "updated": "Test account updated.",
    "deleted": "Test account deleted.",
    "deleteTitle": "Delete {{label}}?",
    "deleteBody": "The account and its record of looks are deleted; testers no longer see it.",
    "empty": "No test accounts yet. If the app needs a login, add it here rather than writing passwords in the instructions.",
    "holder": "Holder",
    "free": "Free",
    "everyone": "Everyone",
    "looks": "Looks",
    "release": "Take back",
    "released": "The account is free again.",
    "showLog": "Show who looked",
    "hideLog": "Hide who looked",
    "noLooks": "Nobody has looked at a password yet."
  },
  "invoice": {
    "title": "Invoices",
    "orgHint": "The e-Fatura / e-Arşiv invoices TestRome issues to you: membership payments, paid featured listings and (when a commission applied) statement fees. They are prepared with the payment and issued shortly after.",
    "mineTitle": "My invoices",
    "mineHint": "e-Arşiv invoices for your membership payments and the featured listings you paid for your team.",
    "none": "No invoices yet.",
    "number": "Invoice no",
    "description": "Description",
    "vat": "VAT",
    "draft": "Draft",
    "nextTry": "Next try: {{at}}",
    "kind": {
      "EArsiv": "e-Arşiv invoice",
      "EFatura": "e-Fatura"
    },
    "status": {
      "Pending": "Waiting",
      "Retrying": "Will retry",
      "Issued": "Issued",
      "Failed": "Not sent",
      "Cancelled": "Cancelled"
    },
    "back": {
      "org": "Billing",
      "my": "My earnings",
      "admin": "Platform billing",
      "orgMembership": "Membership",
      "myMembership": "My membership"
    },
    "doc": {
      "draftTitle": "Draft invoice",
      "date": "Issued: {{date}}",
      "buyer": "Bill to",
      "details": "Invoice details",
      "scenario": "Scenario",
      "type": "Invoice type",
      "currency": "Currency",
      "taxLine": "Tax office: {{office}} · VKN: {{number}}",
      "tcknLine": "National ID: {{number}}",
      "lines": "Goods / services",
      "item": "Description",
      "quantity": "Qty",
      "unitPrice": "Unit price",
      "vatRate": "VAT rate",
      "vatAmount": "VAT",
      "lineTotal": "Amount",
      "subtotal": "Goods / services total",
      "vat": "VAT ({{rate}})",
      "withTaxes": "Total incl. taxes",
      "payable": "Amount payable",
      "cancelled": "This invoice was cancelled on {{date}}: {{reason}}",
      "note": "This is a view of the e-Fatura / e-Arşiv invoice; its valid copy is verified by its ETTN with the integrator and the Revenue Administration (GİB).",
      "draftNote": "This invoice has not been issued yet; its number and date are final once it reaches the integrator."
    }
  },
  "invoiceAdmin": {
    "title": "e-Fatura / e-Arşiv",
    "hint": "Invoices for the platform fee of paid statements and for paid featured listings. Failed sends are retried a few times, then wait here.",
    "provider": "Integrator",
    "simulated": "Simulated",
    "none": "Not configured",
    "pending": "Waiting",
    "failed": "Not sent",
    "issuedThisMonth": "Issued this month",
    "vatThisMonth": "VAT: ₺{{amount}}",
    "noProvider": "No e-invoice integrator is configured: invoices are prepared and wait. They are sent in order once one is configured.",
    "simulatorFailing": "Integrator refuses (simulation)",
    "simulatorDown": "The simulated integrator refuses invoices right now; new invoices wait and are retried.",
    "filter": "By status",
    "sendNow": "Send now",
    "sent": "{{number}} issued.",
    "notSent": "Not sent: {{error}}",
    "cancel": "Cancel",
    "cancelTitle": "Cancel {{number}}?",
    "cancelIssued": "The e-Arşiv invoice is cancelled at the integrator and the customer is told. The amount is not refunded automatically.",
    "cancelDraft": "This invoice has not been issued; cancelled, it is never sent.",
    "reason": "Reason",
    "cancelled": "Invoice cancelled."
  },
  "crash": {
    "title": "This page could not be shown",
    "body": "Something unexpected went wrong and our team has been told. You can reload the page or try again.",
    "reload": "Reload the page",
    "retry": "Try again"
  },
  "errorTracking": {
    "title": "Errors",
    "subtitle": "Unexpected errors in the API, background jobs and people's browsers; the same error is counted on one row.",
    "test": "Send a test error",
    "testSent": "Test error sent; it shows up in the list in a few seconds.",
    "open": "Open",
    "regressedTile": "Back again",
    "last24": "Seen in the last 24 hours",
    "releaseNow": "Running release",
    "list": "Error groups",
    "byStatus": "By status",
    "bySource": "By source",
    "noneOpen": "No open errors.",
    "none": "Nothing here.",
    "details": "Details",
    "count": "How many times",
    "seen": "last: {{last}} · first: {{first}}",
    "regressed": "Back again",
    "resolve": "Resolved",
    "ignore": "Ignore",
    "reopen": "Reopen",
    "kind": "Type",
    "release": "Release",
    "lastUser": "Last seen by",
    "browser": "Browser",
    "source": {
      "Api": "API",
      "Worker": "Background job",
      "Web": "Web app"
    },
    "status": {
      "Open": "Open",
      "Resolved": "Resolved",
      "Ignored": "Ignored"
    },
    "changed": {
      "Open": "Error reopened.",
      "Resolved": "Marked resolved; it opens again if it happens again.",
      "Ignored": "Ignored; it is still counted."
    }
  },
  "duplicates": {
    "copyOf": "copy of #{{n}}",
    "copies_one": "{{count}} copy",
    "copies_other": "{{count}} copies",
    "suspected": "Possible copy of #{{n}}",
    "suspectedLong": "Looks like an earlier report:",
    "isCopyOf": "This report is a copy of",
    "match": "{{percent}}% alike",
    "markAsCopy": "Mark as a copy",
    "marked": "Marked as a copy.",
    "turnedRound": "This report came before #{{n}}: it is now the group's first report and #{{n}} was marked as its copy. The bounty goes to the first reporter.",
    "groupHint": "This is the group's first report; later reports of the same problem are linked here and only the first reporter earns the bounty.",
    "firstIsPaid": "When the same problem is reported more than once, the bounty goes to the first reporter.",
    "alreadyReported": "Similar reports exist in this cycle",
    "yours": "Yours",
    "showCopies": "Show copies",
    "reason": {
      "sameStep": "same step",
      "sameCase": "same case",
      "similarTitle": "similar title",
      "similarResult": "similar result"
    }
  },
  "automation": {
    "toTest": "Turn into an automated test",
    "title": "Playwright test",
    "hint": "Generated from this accepted run's recording: the pages opened, the clicks and the fields filled, split into the test case's steps.",
    "summary": "{{actions}} actions, {{assertions}} checks (page addresses and quoted text in expected results). The recording does not keep what was typed; sign-in fields read environment variables, the rest the file's VALUES.",
    "env": "Environment variables:",
    "values": "Values to fill:",
    "copy": "Copy",
    "copied": "Test copied.",
    "copyFailed": "Could not copy; download the file.",
    "download": "Download ({{name}})",
    "cycle": "Playwright tests",
    "cycleHint": "A ready-to-run Playwright project (zip) with one test per test case from the accepted web runs"
  },
  "ci": {
    "title": "Start tests from CI",
    "hint": "For every build (e.g. every pull request) a copy of a template cycle is published; testers do the work and the result goes back to GitHub as a commit status and a PR comment, or to the CI output.",
    "newKey": "New CI key",
    "newKeyHint": "The key starts runs and reads their result in this project only, with the rights of the person who created it.",
    "name": "Name",
    "nameHint": "Which pipeline uses it: GitHub Actions, GitLab, Jenkins…",
    "template": "Template cycle",
    "templateHint": "The cycle copied for every build: cases, instructions, environments, testers and fees come from it. A CI call may name another template.",
    "noTemplate": "Create a cycle first",
    "failOn": "Bugs that fail the build",
    "failOnHint": "Which open (new or confirmed) bugs make the build fail.",
    "failOnValue": {
      "Critical": "Critical",
      "Major": "Major and above",
      "Minor": "Minor and above",
      "Any": "Any bug",
      "Never": "None (report only)"
    },
    "create": "Create key",
    "createdTitle": "Key \"{{name}}\" is ready",
    "createdHint": "This key is shown only now; copy it into your CI's secrets.",
    "key": "CI key",
    "step1": "GitHub: Settings → Secrets and variables → Actions → New repository secret: TESTROME_TOKEN (GitLab: Settings → CI/CD → Variables, masked).",
    "step2": "Add the configuration below to your repository.",
    "step3": "Connect GitHub in the organization settings so results are written to the pull request.",
    "savedIt": "I saved it",
    "noKeys": "No CI keys yet.",
    "managersOnly": "CI keys are created by the organization's owners and admins.",
    "keyTemplate": "template: {{name}}",
    "keyNoTemplate": "template: given in the call",
    "keyFailOn": "threshold: {{value}}",
    "lastUsed": "last used {{when}}",
    "neverUsed": "never used",
    "revoke": "Revoke key",
    "revokeTitle": "Revoke the CI key?",
    "revokeBody": "Pipelines using this key stop working at once. Runs already started go on.",
    "revoked": "Key revoked.",
    "where": "CI",
    "snippetSecret": "add TESTROME_TOKEN as a secret",
    "snippetWait": "Ask for the state: Running, Passed, Failed, Incomplete or Cancelled",
    "snippetPreview": "add --target-url for a preview deployment, --wait to wait for the result",
    "note1": "A job re-run for the same commit does not open another cycle; --cancel-previous stops the older build of the same pull request.",
    "note2": "With --wait the job waits for the result: exit 0 when it passes, 1 when it fails or is incomplete. Manual testing can take hours, so most teams read the PR comment instead.",
    "note3": "A run is over when every case has a decided run, when its time is up or when the cycle is closed.",
    "build": "Build",
    "cycle": "Cycle",
    "result": "Result",
    "started": "Started",
    "job": "CI job",
    "fromCi": "Started from CI",
    "reportError": "Could not write to GitHub: {{error}}",
    "state": {
      "Running": "Testing",
      "Passed": "Passed",
      "Failed": "Failed",
      "Incomplete": "Incomplete",
      "Cancelled": "Cancelled"
    }
  },
  "recommend": {
    "title": "Testers who fit this job",
    "none": "No freelancer outside this job meets its requirements right now.",
    "footer": "{{considered}} freelancers looked at; {{ineligible}} do not meet the job's requirements (reputation, level, language, device). Ranked by a fitting device, experience with this kind of job, acceptance rate, ratings, confirmed bugs, work for you and availability.",
    "scoreLabel": "Fit {{value}}/100",
    "reason": {
      "device": "Has a fitting device: {{value}}",
      "noDevice": "No device the job asks for",
      "categoryRuns": "{{value}} accepted runs in jobs like this",
      "category": "Works in this kind of job",
      "level": "{{level}} level",
      "acceptance": "{{value}}% accepted",
      "lowAcceptance": "Low acceptance ({{value}}%)",
      "rating": "Rated {{value}} by customers",
      "lowRating": "Low rating ({{value}})",
      "bugs": "{{value}} confirmed bugs",
      "workedWithYou": "{{value}} accepted runs for you",
      "yourRating": "You rated them {{value}}",
      "available": "Available now",
      "busy": "{{value}} open tasks"
    }
  },
  "quality": {
    "title": "Release quality",
    "intro": "Test results for each app version: pass rate, bugs, whether it looks ready to ship, its weak spots, and which devices it was tested on against their use in Türkiye. The version comes from the cycle's \"App version\" field; draft cycles and rejected runs do not count.",
    "version": "Version",
    "noVersion": "No version",
    "emptyTitle": "No published test cycles yet",
    "emptyBody": "As cycles are published and tested, each version's quality shows up here. Remember to enter the app version in the cycle wizard.",
    "trendTitle": "Pass rate by version",
    "trendHint": "Bar height is the pass rate, its colour the verdict. Click a version to open its details.",
    "trendLabel": "Pass rates of the versions",
    "trendItem": "{{version}}: pass rate {{rate}}, {{bugs}} bugs, {{verdict}}",
    "bugCount_one": "{{count}} bug",
    "bugCount_other": "{{count}} bugs",
    "verdict": {
      "Ready": "Ready to ship",
      "Risky": "Risky",
      "NotReady": "Not ready",
      "NoData": "No data"
    },
    "verdictTitle": "Version {{version}}",
    "verdictTitleNone": "Cycles without a version",
    "verdictMeta": "{{cycles}} cycles · {{from}} – {{to}}",
    "verdictLead": {
      "Ready": "Based on the test results, this version looks ready to ship.",
      "Risky": "It could ship, but it is risky: look at these first.",
      "NotReady": "This version is not ready to ship yet.",
      "NoData": "No tests have been submitted for this version yet."
    },
    "finding": {
      "allClear": "Pass rate {{value}}%; no open critical or major bugs.",
      "openCritical": "{{value}} open critical bugs.",
      "lowPassRate": "The pass rate is too low: {{value}}% (at least 70% needed).",
      "passRate": "Pass rate {{value}}% (at least 90% to count as ready).",
      "openMajor": "{{value}} open major bugs.",
      "untestedCases": "{{value}} of the planned cases were never run.",
      "lowCoverage": "The devices tested cover only {{value}}% of users (at least 50%).",
      "openMinor": "{{value}} open minor or trivial bugs.",
      "pendingReview": "{{value}} runs are not reviewed yet.",
      "testing": "Testing is still going on; results may change.",
      "noRuns": "No runs have been submitted yet."
    },
    "passRate": "Pass rate",
    "outcomes": "{{passed}} passed · {{failed}} failed · {{blocked}} blocked",
    "comparedTo": "compared with {{version}}",
    "deltaPoints": "{{value}} pts",
    "deltaCount": "{{value}}",
    "same": "no change",
    "bugs": "Bugs",
    "openFixed": "{{open}} open · {{fixed}} fixed",
    "cases": "Cases run",
    "runsLine": "{{runs}} runs · {{pending}} awaiting review",
    "coverage": "Device coverage",
    "coverageHint": {
      "Web": "Share of use in Türkiye of the device types and systems tested",
      "Android": "Share of use in Türkiye of the Android versions tested",
      "Ios": "Share of use in Türkiye of the iOS versions tested"
    },
    "coverageTitle": "Device coverage map",
    "coverageIntro": "Which devices, systems and browsers this version was tested on, with their share of use in Türkiye.",
    "reach": {
      "Web": "Share of the device types and systems used by web visitors in Türkiye that were tested: {{value}}.",
      "Android": "Share of Android users in Türkiye on a tested system version: {{value}}.",
      "Ios": "Share of iPhone and iPad users in Türkiye on a tested iOS version: {{value}}."
    },
    "gapsTitle": "Biggest gaps",
    "gap": "{{label}} · {{value}}",
    "gapsHint": "Percentages are shares of users in Türkiye. Add them to the next cycle's environment matrix or invite testers who own these devices.",
    "gapIn": {
      "mobileBrowser": "{{label}} (phone)",
      "desktopBrowser": "{{label}} (desktop)",
      "mobileOs": "{{label}} phones",
      "desktopOs": "{{label}} computers"
    },
    "group": {
      "platform": "Device type",
      "mobileOs": "Phone system",
      "androidVersion": "Android versions",
      "iosVersion": "iOS versions",
      "desktopOs": "Computer system",
      "windowsVersion": "Windows versions",
      "mobileBrowser": "Phone browsers",
      "desktopBrowser": "Desktop browsers"
    },
    "groupCovered": "{{value}} covered",
    "runs_one": "{{count}} run",
    "runs_other": "{{count}} runs",
    "notTested": "not tested",
    "other": "Environments not in the list: {{list}}.",
    "unknown_one": "The device of {{count}} run could not be told.",
    "unknown_other": "The device of {{count}} runs could not be told.",
    "source": "Usage shares: {{name}}, Türkiye, {{period}}.",
    "sourceLink": "Source",
    "weakTitle": "Weak spots",
    "weakHint": "Cases that failed, were blocked or found bugs",
    "noWeakAreas": "No failed cases or bugs in this version.",
    "exploratory": "Exploratory testing",
    "weakLine": "{{runs}} runs · {{failed}} failed/blocked · {{bugs}} bugs · pass {{rate}}",
    "cyclesTitle": "Cycles of this version",
    "cycleLine": "{{runs}} runs · pass {{rate}} · {{bugs}} bugs",
    "report": "Report"
  },
  "duration": {
    "s": "{{s}}s",
    "m": "{{m}} min",
    "ms": "{{m}} min {{s}}s",
    "h": "{{h}} h",
    "hm": "{{h}} h {{m}} min",
    "d": "{{d}} d",
    "dh": "{{d}} d {{h}} h"
  },
  "idle": {
    "threshold": "Breaks",
    "thresholdHint": "Pauses longer than this are shown. The choice is kept in this browser.",
    "off": "Breaks hidden",
    "atLeast": "Breaks: {{duration}} or more",
    "logGap": "{{duration}} break · previous action {{at}}",
    "logGapUser": "{{name}}: {{duration}} break · previous action {{at}}",
    "title": "Time and breaks",
    "total": "Total",
    "active": "Working",
    "idle": "Breaks",
    "hidden": "Breaks are hidden; pick a length to show them.",
    "none": "No breaks of {{duration}} or more.",
    "summary_one": "{{count}} break, {{share}}% of the time.",
    "summary_other": "{{count}} breaks, {{share}}% of the time.",
    "summaryHidden": "The app was off screen for {{hidden}} of it.",
    "between": "Before: {{from}} · after: {{to}}",
    "offScreen": "app off screen for {{duration}}",
    "inStep": "{{duration}} break",
    "kind": {
      "start": "started the run",
      "end": "submitted",
      "Click": "clicked",
      "Input": "typed in a field",
      "Navigation": "changed page",
      "Checkpoint": "reached a checkpoint",
      "Session": "opened the app",
      "VisibilityChange_from": "left the app",
      "VisibilityChange_to": "came back to the app",
      "execution_started": "started the run",
      "execution_submitted": "submitted",
      "step_started": "started a step",
      "step_completed": "completed a step",
      "evidence_uploaded": "uploaded evidence",
      "bug_reported": "reported a bug",
      "execution_notes_saved": "wrote notes",
      "execution_video_uploaded": "uploaded the screen recording",
      "execution_video_started": "started the screen recording",
      "execution_app_opened": "opened the app on the phone",
      "execution_pairing_code_created": "got a pairing code",
      "execution_phone_link_created": "got a phone link",
      "execution_video_marked": "marked steps in the recording",
      "execution_relaunched": "restarted the run",
      "other": "did something"
    }
  },
  "appearance": {
    "title": "Appearance",
    "description": "Each look is drawn in its own colours and typeface. The one you pick applies at once and is kept in this browser.",
    "open": "Compare looks…",
    "current": "Current look",
    "desc": {
      "system": "Follows your computer's light or dark setting.",
      "light": "Mineral paper, dark green ink, a violet accent.",
      "dark": "The same look in dark, for long review sessions.",
      "fosforlu": "Paper white and ink blue; where you are is marked with a highlighter.",
      "ozalit": "Blueprint blue, a drafting grid and cyan linework; every page like a technical drawing."
    }
  },
  "rhythm": {
    "period": "Period",
    "periods": {
      "7d": "Last 7 days",
      "30d": "Last 30 days",
      "90d": "Last 90 days"
    },
    "cycle": "Cycle",
    "allCycles": "All cycles",
    "job": "Job",
    "allJobs": "All jobs",
    "otherCycle": "Selected cycle",
    "tester": "Tester",
    "allTesters": "All testers",
    "otherTester": "Selected person",
    "thresholdHint": "Pauses longer than this count as breaks. The choice is shared with the log and the review page and kept in this browser.",
    "note": "This dashboard shows how the work went; it does not affect confidence scores or pay. Screen-video runs only know the steps done in TestRome, so their breaks are measured more coarsely.",
    "truncated": "This selection has too many runs; only the latest {{max}} submitted runs were analyzed. Narrow the period or pick a cycle.",
    "emptyTitle": "No submitted runs in this period",
    "emptyBody": "Widen the period or clear the filters.",
    "reviewersOnlyTitle": "Work rhythm is for reviewers",
    "reviewersOnlyBody": "This tab is open to owners, admins and reviewers.",
    "kpi": {
      "runs": "Runs analyzed",
      "runsSub": "Submitted in this period",
      "runsCoarse_one": "{{count}} is a screen video: coarse measure",
      "runsCoarse_other": "{{count}} are screen videos: coarse measure",
      "withBreaks": "Runs with a break",
      "withBreaksSub_one": "{{share}} of runs · {{count}} break",
      "withBreaksSub_other": "{{share}} of runs · {{count}} breaks",
      "breakTime": "Total break time",
      "breakTimeSub": "{{share}} of working time",
      "active": "Active time per run",
      "activeSub": "Breaks left out; {{total}} in all",
      "hidden": "Breaks off screen",
      "hiddenSub": "The app was off screen for {{duration}}",
      "hiddenNone": "No breaks at this threshold"
    },
    "showTable": "Show as a table",
    "showChart": "Show as a chart",
    "lengthTitle": "Break lengths",
    "lengthHint": "Every pause over a minute; those under the threshold do not count as breaks.",
    "legendBreak": "Break ({{duration}} or more)",
    "legendShort": "Under the threshold",
    "bucket": {
      "1-2": "1–2 min",
      "2-5": "2–5 min",
      "5-15": "5–15 min",
      "15+": "15 min+"
    },
    "bucketTip_one": "{{count}} pause · {{duration}} in all",
    "bucketTip_other": "{{count}} pauses · {{duration}} in all",
    "counted": "Counts as a break",
    "notCounted": "Under the threshold, not a break",
    "trendTitle": "Daily trend",
    "trendHint": "Runs submitted each day; those with a break at the bottom.",
    "trendLabel": "Daily runs chart. Move between days with the arrow keys.",
    "legendWithBreaks": "Run with a break",
    "legendWithout": "Run without a break",
    "tipWithBreaks": "with a break",
    "tipWithout": "without",
    "dayRuns_one": "{{count}} run",
    "dayRuns_other": "{{count}} runs",
    "dayWithBreaks_one": "{{count}} with a break",
    "dayWithBreaks_other": "{{count}} with a break",
    "dayBreakTime": "{{duration}} of breaks",
    "col": {
      "day": "Day",
      "runs": "Runs",
      "withBreaks": "With a break",
      "breaks": "Breaks",
      "breakTime": "Break time",
      "length": "Length",
      "pauses": "Pauses",
      "counted": "Status",
      "tester": "Tester",
      "perRun": "Breaks / run",
      "longest": "Longest break",
      "share": "Share in breaks",
      "case": "Case",
      "topStep": "Step with most breaks"
    },
    "testersTitle": "Testers",
    "testersHint": "Most break time first.",
    "testersHintLogs": "Most break time first. Click a name to open that person's log.",
    "openLogsOf": "{{name}}: open the log",
    "casesTitle": "Cases and steps",
    "casesHint": "The cases with the most break time (up to 10); the runs column shows runs with a break out of all.",
    "casesNone": "No breaks in cases at this threshold.",
    "exploratory": "Exploratory testing",
    "stepBreaks_one": "{{count}} break, {{duration}}",
    "stepBreaks_other": "{{count}} breaks, {{duration}}",
    "longestTitle": "Longest breaks",
    "longestHint": "Click to go to that moment of the recording.",
    "longestHintLogs": "Click to open that run's log.",
    "longestNone": "No breaks at this threshold.",
    "openRecording": "Go to recording",
    "openLogs": "Open in log",
    "coarse": "Screen video: coarse measure"
  },
  "membership": {
    "titleOrg": "Membership",
    "subtitleOrg": "Everyone in your organization works under this membership",
    "titleMine": "My membership",
    "subtitleMine": "Your own membership for marketplace jobs; community work is covered by the organization",
    "state": {
      "NotStarted": "Not started",
      "Trial": "Trial",
      "Active": "Active",
      "PastDue": "Payment due",
      "Cancelled": "Cancelled",
      "Granted": "Granted",
      "Expired": "Expired"
    },
    "interval": {
      "Monthly": "Monthly",
      "Yearly": "Yearly"
    },
    "per": {
      "Monthly": "/ month",
      "Yearly": "/ year"
    },
    "line": {
      "NotStarted": "Marketplace jobs need a membership. Your {{days}}-day trial starts with your first application.",
      "Trial_one": "Your trial ends on {{date}}. Choose a plan to keep working after that.",
      "Trial_other": "Your trial ends on {{date}}. Choose a plan to keep working after that.",
      "Active": "{{plan}}. The next renewal is charged to the saved card on {{date}}.",
      "PastDue": "The last renewal could not be charged. It will be retried; your access lasts until {{date}}. To use another card, pay again below.",
      "CancelledOpen": "The membership was cancelled and will not renew. You can keep working until {{date}}.",
      "Granted": "A membership granted by the platform, valid until {{date}}.",
      "GrantedForever": "A membership granted by the platform with no end date.",
      "Expired": "The membership has ended. Your data stays and can be viewed, but no new work can be started. Choose a plan to continue.",
      "ExpiredTester": "Your membership has ended. Choose a plan to apply to new marketplace jobs; your community work is not affected."
    },
    "daysLeft_one": "{{count}} day left",
    "daysLeft_other": "{{count}} days left",
    "notRequired": "Testers do not need a membership right now; you can apply to marketplace jobs without one.",
    "notRequiredTitle": "No membership needed",
    "lastError": "Provider response: {{error}}",
    "nextPlan": "From {{date}} the membership switches to {{plan}} ({{amount}}).",
    "lockedOrg": "Projects, cycles and results stay visible; starting cycles, adding tests and inviting people need a membership.",
    "lockedTester": "Applying to marketplace jobs and starting new runs need a membership.",
    "managersOnly": "Owners and admins of the organization manage the membership.",
    "statusTitle": "Status",
    "plansTitle": "Plans",
    "plansHintOrg": "Prices include VAT. No commission: nothing is added on top of what you pay testers.",
    "plansHintTester": "Prices include VAT. No commission is taken from your earnings.",
    "saving": "Save {{percent}}%",
    "currentPlan": "Current plan",
    "nextPlanBadge": "Next plan",
    "vatIncluded": "VAT included",
    "perMonthApprox": "about {{amount}} a month",
    "start": "Start membership",
    "payNewCard": "Pay with another card",
    "switch": "Switch to this plan",
    "keepPlan": "Stay on this plan",
    "keepDone": "The plan change was undone",
    "switchScheduled": "Switches to this plan on {{date}}.",
    "switchTitle": "Switch to {{plan}}?",
    "switchBody": "The change starts when the current period ends on {{date}}; {{amount}} ({{interval}}) is charged to the saved card that day.",
    "switchDone": "The plan changes on {{date}}",
    "cancel": "Cancel membership",
    "cancelTitle": "Cancel the membership?",
    "cancelBody": "Automatic renewal stops. You keep working until {{date}}; after that nothing is deleted, but no new work can be started.",
    "cancelConfirm": "Cancel membership",
    "cancelled": "Membership cancelled; it will not renew",
    "startsToday": "The first period starts on the day you pay; remaining trial or earlier period days are not added.",
    "noPlans": "No plans are available right now; contact the platform admin.",
    "autoRenew": "Payment is taken on iyzico's secure page and renews automatically from the same card at the end of each period. Cancel any time. Every payment gets an e-Arşiv / e-Fatura invoice.",
    "blocker": {
      "notConfigured": "Card payments are not enabled on this installation; contact the platform admin.",
      "billing": "Fill in the billing details (including the contact's T.C. identity number, phone and address) before paying by card."
    },
    "fillBilling": "Go to billing details",
    "paymentsTitle": "Payments",
    "paymentsHint": "Each payment's invoice is prepared with the payment.",
    "paidAt": "Date",
    "plan": "Plan",
    "period": "Period",
    "amount": "Amount",
    "invoice": "Invoice",
    "forever": "no end date",
    "buyerTitle": "Invoice and payment details",
    "buyerHint": "{{plan}} · {{interval}} · {{amount}}. These details go on your invoice and the iyzico payment record.",
    "identityAgain": "Saved: {{masked}} — enter it again for security",
    "toPayment": "Go to payment",
    "checkoutDone": "Payment received; your membership has started. Your invoice is being prepared.",
    "checkoutFailed": "The payment did not go through and nothing was charged. You can try again.",
    "openPage": "Membership page",
    "banner": {
      "Trial_one": "{{count}} day left in the trial ({{date}}).",
      "Trial_other": "{{count}} days left in the trial ({{date}}).",
      "PastDue": "The membership renewal could not be charged. Access lasts until {{date}}.",
      "Cancelled": "The membership was cancelled and ends on {{date}}.",
      "Expired": "The membership has ended: data stays visible, but no new work can be started.",
      "ExpiredTester": "Marketplace jobs need a membership; your community work is not affected.",
      "choose": "Choose a plan",
      "open": "Open membership",
      "askManager": "Ask an admin of your organization"
    }
  },
  "membershipAdmin": {
    "title": "Memberships",
    "provider": "Payment provider: {{name}}",
    "simulation": "Simulation",
    "mrr": "Monthly recurring revenue",
    "mrrHint": "Yearly plans divided by 12",
    "settings": "Settings",
    "settingsHint": "The trial applies to new organizations and to testers applying to the marketplace for the first time.",
    "trialDays": "Trial (days)",
    "trialDaysHint": "0: no trial",
    "graceDays": "Grace period (days)",
    "graceDaysHint": "How long access lasts after a failed renewal",
    "fee": "Commission (%)",
    "feeHint": "0: no commission. Added on top of tester payments.",
    "testerRequired": "Require a membership from testers for marketplace jobs",
    "testerRequiredHint": "When off, testers apply to the marketplace without one. Community work is always covered by the organization's membership.",
    "plans": "Plans and prices",
    "plansHint": "Prices include VAT. The saving between monthly and yearly plans of the same name is worked out automatically.",
    "newPlan": "Add plan",
    "editPlan": "Edit plan",
    "planHint": "A plan's name, features and order can always change.",
    "priceLocked": "The price, period and audience of a plan in use cannot change: add a new plan and switch this one off; current members stay on it until they change.",
    "audience": "For",
    "audienceOf": {
      "Organization": "Organization",
      "Tester": "Tester"
    },
    "planName": "Plan name",
    "price": "Price (₺, VAT incl.)",
    "priceHint": "Charged to the card every period",
    "description": "Short description",
    "features": "Features",
    "featuresHint": "One per line",
    "featureCount_one": "{{count}} feature",
    "featureCount_other": "{{count}} features",
    "sortOrder": "Order",
    "active": "On sale",
    "simulatorTitle": "Renewal simulation",
    "simulatorHint": "With the simulated provider, memberships renew here when their period ends. Make renewals fail to try the failure flow.",
    "failRenewals": "Make renewals fail (card declined)",
    "subjects": "Organizations and testers",
    "subjectsHint": "Extend a trial or grant free access until a date.",
    "filterLabel": "Showing",
    "filter": {
      "all": "All",
      "Organization": "Organizations",
      "Tester": "Testers",
      "attention": "Needs attention"
    },
    "noRows": "Nothing to show.",
    "subject": "Account",
    "status": "Status",
    "accessUntil": "Access until",
    "paid": "Paid",
    "renewNow": "Renew now",
    "renewed": "Renewal run",
    "subjectHint": "Changes apply at once.",
    "trialEnds": "Trial ends",
    "trialEndsHint": "Ends at the end of that day (Türkiye time).",
    "grant": "Free access",
    "grantHint": "No payment is asked until the date; independent of any subscription.",
    "grantUntil": "Until",
    "forever": "No end date",
    "grantNote": "Note (shown to the member)",
    "clearGrant": "Remove free access"
  }
}
